<template>
    <div class="cont-table">

        <div class="spin">
            <ion-spinner name="crescent"></ion-spinner>
        </div>

        <div class="row cont_agila_pratiche">
            <div class=" " style="margin:0 auto;">
                <div class="card">

                    <div class="card-body" style="padding:0px">

                        <div class="table-responsive" style="">

                            <table id="myTable" style="margin-top:57px">
                                <thead>
                                    <tr>

                                        <th class='all'>
                                            <div class="cl_checkall">
                                                <ion-checkbox style="width:10px!important;height:10px!important"
                                                    class='checkall'>
                                                </ion-checkbox>
                                            </div>
                                        </th>
                                        <th class='all' style="text-align: center;">
                                            <div>N.</div>
                                        </th>
                                        <th class='all'>Codice</th>
                                        <th class='all'>Pratica</th>
                                        <th class='all'>Azienda</th>
                                        <th class='all'>Referente</th>
                                        <th class='desktop'>Gestore</th>
                                        <th class='desktop'>Tipo Prog.</th>
                                        <th class='desktop'>
                                            <div style="width:99px">Data Inoltro Dom.</div>
                                        </th>
                                        <th class='desktop'>Note</th>
                                        <th class='desktop'>Stato</th>
                                        <th class='desktop' style="text-align:center">Fatturato</th>
                                        <th class='desktop' style="text-align:center">Pagato</th>
                                        <th class='desktop' style="text-align:right">
                                            <div>Contributo (€)</div>
                                        </th>
                                        <th class='desktop' style="text-align:right">
                                            <div style="width:92px">Investimento (€)</div>
                                        </th>
                                        <th class='desktop' style="text-align:right;padding-right:5px">Previsionale (€)
                                        </th>


                                        <th class='desktop' style="text-align:right;padding-right:5px">Imp. Fatture (€)
                                        </th>

                                        <th class='desktop' style="text-align:right;padding-right:5px">Imp. Riman. (€)
                                        </th>


                                        <th class='desktop' style="text-align:center">Mandato</th>
                                        <th class='desktop' style="text-align:center">Doxweb</th>
                                        <th class='desktop'>
                                            <div style="width:105px">Nickname Doxweb</div>
                                        </th>

                                    </tr>
                                </thead>

                                <tfoot>

                                    <tr>
                                        <th colspan="21">
                                        </th>
                                    </tr>
                                </tfoot>

                            </table>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="contpopupsearch" style="display:none">

            <template>
                <modal name="popupSearch" :clickToClose="false" :width="262" :height="215">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            <v-img alt="" src="@/assets/ricerca_emt.png" max-width="25" max-height="25" />

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <v-text-field v-model="textSearch" label="" id="fldSearch">
                            </v-text-field>

                        </v-col>

                    </v-row>



                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-search" contain src="@/assets/btn_cancel3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" @click="btnCancelSearch" />

                                <v-img alt="" class="btn-confirm-search" contain src="@/assets/btn_confirm3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer" transition="scale-transition"
                                    title="Conferma" @click="btnConfirmSearch" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


        <div class="contaziende">

            <template>
                <div class="text-center">
                    <v-bottom-sheet v-model="sheetAziende" class="vaziendesheet">
                        <v-sheet class="text-center" height="100vh">
                            <div class="headerSheetAziende" fixed style="position:fixed;">
                                Aziende
                                <v-btn class='closeSheet align_close_sheet' icon @click="sheetAziende = !sheetAziende">

                                    <v-img alt="Proprietario Logo" class="  " contain src="@/assets/btn_cancel3_emt.png"
                                        max-width="24" max-height="24" style="margin-right:13px"
                                        transition="scale-transition" />

                                </v-btn>

                                <v-toolbar>
                                    <v-text-field hide-details prepend-icon="mdi-magnify" single-line v-model="search"
                                        id="fldTextSearchAzi">
                                    </v-text-field>

                                </v-toolbar>

                            </div>

                            <v-divider></v-divider>

                            <div class="spacer" style="min-height:72px;"></div>

                            <v-flex xs12 sm12>
                                <v-card>

                                    <v-list-item class="text-left" v-for="item in filteredAziende" :key="item.companyid"
                                        @click="manageClickAziende(item)">

                                        <v-img alt="" src="@/assets/aziende-emt.png" max-width="24" max-height="24" />

                                        <v-list-item-title class='itemAzienda'>{{ item.fld_name }}</v-list-item-title>

                                    </v-list-item>

                                    <div style="min-height:150px;height:150px">&nbsp;</div>

                                </v-card>
                            </v-flex>
                        </v-sheet>
                    </v-bottom-sheet>
                </div>
            </template>
        </div>



        <div class="contaziende">

            <template>
                <div class="text-center">
                    <v-bottom-sheet v-model="sheetClienti" class="vaziendesheet" style="z-index:999999">
                        <v-sheet class="text-center" height="100vh">
                            <div class="headerSheetAziende" fixed style="position:fixed;">
                                Clienti
                                <v-btn class='closeSheet align_close_sheet' icon @click="sheetClienti = !sheetClienti">

                                    <v-img alt="Proprietario Logo" class="  " contain src="@/assets/btn_cancel3_emt.png"
                                        max-width="24" max-height="24" style="margin-right:13px"
                                        transition="scale-transition" />

                                </v-btn>

                                <v-toolbar>
                                    <v-text-field hide-details prepend-icon="mdi-magnify" single-line v-model="search"
                                        id="fldTextSearchAzi">
                                    </v-text-field>

                                </v-toolbar>

                            </div>

                            <v-divider></v-divider>

                            <div class="spacer" style="min-height:72px;"></div>

                            <v-flex xs12 sm12>
                                <v-card>

                                    <v-list-item class="text-left" v-for="item in filteredAziende" :key="item.companyid"
                                        @click="manageClickClienti(item)">

                                        <v-img alt="" src="@/assets/aziende-emt.png" max-width="24" max-height="24" />

                                        <v-list-item-title class='itemAzienda'>{{ item.fld_name }}</v-list-item-title>

                                    </v-list-item>

                                    <div style="min-height:150px;height:150px">&nbsp;</div>

                                </v-card>
                            </v-flex>
                        </v-sheet>
                    </v-bottom-sheet>
                </div>
            </template>
        </div>



        <div class="text-left">
            <v-bottom-sheet v-model="sheetProjectType">
                <v-sheet class="text-center" height="340px" style="padding-bottom:120px;">
                    <v-btn class='closeStatusSheet' icon @click="sheetProjectType = !sheetProjectType">

                        <v-img alt="Proprietario Logo" style="margin-right:23px" class="  " contain
                            src="@/assets/btn_cancel3_emt.png" max-width="24" max-height="24"
                            transition="scale-transition" />

                    </v-btn>
                    <div class="py-3">
                        Tipo Progetto
                    </div>
                    <v-list-item v-for="prj in projectType" :key="prj.id" @click="filterProjectType(prj.id)">
                        <v-list-item-title style="justify-content: center;text-align: left;">{{
                            prj.nome
                        }}</v-list-item-title>
                    </v-list-item>
                </v-sheet>
            </v-bottom-sheet>
        </div>

        <div class="text-left">
            <v-bottom-sheet v-model="sheetControlType">
                <v-sheet class="text-center" height="340px" style="padding-bottom:120px;">
                    <v-btn class='closeStatusSheet' icon @click="sheetControlType = !sheetControlType">

                        <v-img alt="Proprietario Logo" style="margin-right:23px" class="  " contain
                            src="@/assets/btn_cancel3_emt.png" max-width="24" max-height="24"
                            transition="scale-transition" />

                    </v-btn>
                    <div class="py-3">
                        Tipo
                    </div>
                    <v-list-item v-for="prj in controlType" :key="prj.id" @click="filterControlType(prj.id)">
                        <v-list-item-title style="justify-content: center;text-align: left;">{{
                            prj.descrizione
                        }}</v-list-item-title>
                    </v-list-item>
                </v-sheet>
            </v-bottom-sheet>
        </div>

        <div class="text-left">
            <v-bottom-sheet v-model="sheetStatus">
                <v-sheet class="text-center" height="340px" style="padding-bottom:120px;">
                    <v-btn class='closeStatusSheet' icon @click="sheetStatus = !sheetStatus">

                        <v-img alt="Proprietario Logo" style="margin-right:23px" class="  " contain
                            src="@/assets/btn_cancel3_emt.png" max-width="24" max-height="24"
                            transition="scale-transition" />

                    </v-btn>
                    <div class="py-3">
                        Stato
                    </div>
                    <v-list-item v-for="prj in stati" :key="prj.id" @click="filterStatus(prj.id)">
                        <v-list-item-title style="justify-content: center;text-align: left;">{{
                            prj.descrizione
                        }}</v-list-item-title>
                    </v-list-item>
                </v-sheet>
            </v-bottom-sheet>
        </div>



        <div class="text-left">
            <v-bottom-sheet v-model="sheetReferenti">
                <v-sheet class="text-center" height="340px" style="padding-bottom:120px;">
                    <v-btn class='closeStatusSheet' icon @click="sheetReferenti = !sheetReferenti">

                        <v-img alt="Proprietario Logo" style="margin-right:23px" class="  " contain
                            src="@/assets/btn_cancel3_emt.png" max-width="24" max-height="24"
                            transition="scale-transition" />

                    </v-btn>
                    <div class="py-3">
                        Referente
                    </div>
                    <v-list-item v-for="prj in referenti" :key="prj.id" @click="filterReferente(prj.id)">
                        <v-list-item-title style="justify-content: center;text-align: left;">{{
                            prj.referente
                        }}</v-list-item-title>
                    </v-list-item>
                </v-sheet>
            </v-bottom-sheet>
        </div>


        <div class="contgestori">

            <template>
                <div class="text-center">
                    <v-bottom-sheet v-model="sheetGestori" class="vgestorisheet">
                        <v-sheet class="text-center" height="100vh">
                            <div class="headerSheetGestori" fixed style="position:fixed;">
                                Gestori
                                <v-btn class='closeSheet align_close_sheet' icon @click="sheetGestori = !sheetGestori">

                                    <v-img alt="Proprietario Logo" class="  " contain src="@/assets/btn_cancel3_emt.png"
                                        max-width="24" max-height="24" style="margin-right:13px"
                                        transition="scale-transition" />

                                </v-btn>

                                <v-toolbar>
                                    <v-text-field hide-details prepend-icon="mdi-magnify" single-line
                                        v-model="searchGestore" id="fldTextSearchGest">
                                    </v-text-field>

                                </v-toolbar>

                            </div>

                            <v-divider></v-divider>

                            <div class="spacer" style="min-height:72px;"></div>

                            <v-flex xs12 sm12>
                                <v-card>

                                    <v-list-item class="text-left" v-for="item in filteredGestori" :key="item.login"
                                        @click="manageClickGestori(item)">

                                        <v-img alt="" src="@/assets/tipo-agila-emt.png" max-width="24"
                                            max-height="24" />

                                        <v-list-item-title class='itemGestore'>{{ item.name }}</v-list-item-title>

                                    </v-list-item>
                                </v-card>
                            </v-flex>
                        </v-sheet>
                    </v-bottom-sheet>
                </div>
            </template>
        </div>


        <div class="text-left">
            <v-bottom-sheet v-model="sheetPagamenti">
                <v-sheet class="text-center" height="340px" style="padding-bottom:120px;">
                    <v-btn class='closeStatusSheet' icon @click="sheetPagamenti = !sheetPagamenti">

                        <v-img alt="Proprietario Logo" style="margin-right:23px" class="  " contain
                            src="@/assets/btn_cancel3_emt.png" max-width="24" max-height="24"
                            transition="scale-transition" />

                    </v-btn>
                    <div class="py-3">
                        Stato Pagamento
                    </div>
                    <v-list-item v-for="prj in stati_pagamento" :key="prj.id" @click="filterPagamento(prj.id)">
                        <v-list-item-title style="justify-content: center;text-align: left;">{{
                            prj.descrizione
                        }}</v-list-item-title>
                    </v-list-item>
                </v-sheet>
            </v-bottom-sheet>
        </div>

        <div class="text-left">
            <v-bottom-sheet v-model="sheetIntMand">
                <v-sheet class="text-center" height="340px" style="padding-bottom:120px;">
                    <v-btn class='closeStatusSheet' icon @click="sheetIntMand = !sheetIntMand">

                        <v-img alt="Proprietario Logo" style="margin-right:23px" class="  " contain
                            src="@/assets/btn_cancel3_emt.png" max-width="24" max-height="24"
                            transition="scale-transition" />

                    </v-btn>
                    <div class="py-3">
                        Intestario Mandato
                    </div>
                    <v-list-item v-for="prj in intestatario_mandato" :key="prj.id" @click="filterIntMand(prj.id)">
                        <v-list-item-title style="justify-content: center;text-align: left;">{{
                            prj.descrizione
                        }}</v-list-item-title>
                    </v-list-item>
                </v-sheet>
            </v-bottom-sheet>
        </div>


        <div class="contpopupdateto" style="display:none">

            <template>
                <modal name="popupDateTo" :clickToClose="false" :width="300" :height="275">



                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important">

                            <v-menu v-model="showPicker" :close-on-content-click="false" transitions="scale-transition"
                                offset-y max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field id="fldInpData" v-model="dataDal" label="Dal" persistent-hint readonly
                                        v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="dataDal" no-title @input="showPicker = false" locale="it">
                                </v-date-picker>
                            </v-menu>

                        </v-col>

                    </v-row>



                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important">

                            <v-menu v-model="showPicker2" :close-on-content-click="false" transitions="scale-transition"
                                offset-y max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field id="fldInpData" v-model="dataAl" label="Al" persistent-hint readonly
                                        v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="dataAl" no-title @input="showPicker2 = false" locale="it">
                                </v-date-picker>
                            </v-menu>

                        </v-col>

                    </v-row>


                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-date-to" contain src="@/assets/btn_cancel3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" @click="btnCancelDate" />


                                <v-img alt="" class="btn-reset-date-to" contain src="@/assets/reset.png" max-width="25"
                                    max-height="25" style="cursor:pointer;margin-right:10px;margin-top:3px"
                                    transition="scale-transition" title="Pulisci" @click="btnResetDate" />

                                <v-img alt="" class="btn-confirm-date-to" contain src="@/assets/btn_confirm3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer" transition="scale-transition"
                                    title="Conferma" @click="btnConfirmDate" />

                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


        <div class="text-left">
            <v-bottom-sheet v-model="sheetAnno">
                <v-sheet class="text-center" height="340px" style="padding-bottom:120px;">
                    <v-btn class='closeStatusSheet' icon @click="sheetAnno = !sheetAnno">

                        <v-img alt="Proprietario Logo" style="margin-right:23px" class="  " contain
                            src="@/assets/btn_cancel3_emt.png" max-width="24" max-height="24"
                            transition="scale-transition" />

                    </v-btn>
                    <div class="py-3">
                        Anno
                    </div>
                    <v-list-item v-for="prj in anni" :key="prj.id" @click="filterAnno(prj.id)">
                        <v-list-item-title style="justify-content: center;text-align: left;">{{
                            prj.nome
                        }}</v-list-item-title>
                    </v-list-item>
                </v-sheet>
            </v-bottom-sheet>
        </div>




        <div class="contpopupotpdelete" style="display:none">

            <template>
                <modal name="popupOtpDelete" :clickToClose="false" :width="262" :height="215">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            Codice OTP inviatoLe via mail

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <v-text-field type="password" v-model="valueOtpDelete" label="" id="fldValueOtpDelete">
                            </v-text-field>

                        </v-col>

                    </v-row>



                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-otp-delete" contain src="@/assets/btn_cancel3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" @click="btnCancelOtpDelete" />

                                <v-img alt="" class="btn-confirm-otp-delete" contain src="@/assets/btn_confirm3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer" transition="scale-transition"
                                    title="Conferma" @click="btnConfirmOtpDelete" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>





        <div class="contpopupexportxls" style="display:none">

            <template>
                <modal name="popupExportXls" :clickToClose="false" :width="332" :height="653">


                    <v-row style="margin-bottom: 0px!important;padding-bottom: 0px!important;">

                        <v-col cols="12" md="12"
                            style="margin-top:10px!important;font-weight:bold;margin-left:10px;margin-bottom: 0px!important;padding-bottom: 0px!important;">

                            Esporta XLS

                        </v-col>

                    </v-row>

                    <v-row
                        style="margin-top:0px!important;padding-top: 0px!important;margin-bottom: 0px!important;padding-bottom: 0px!important;">

                        <v-col cols="12" md="12"
                            style="margin-bottom: 0px!important;padding-bottom: 0px!important;margin-top:0px!important;padding-top: 0px!important">

                            <v-text-field v-model="textSearchExportXls" label="Cerca testo" id="fldSearch">
                            </v-text-field>

                        </v-col>

                    </v-row>


                    <v-row
                        style="margin-bottom: 0px!important;padding-bottom: 0px!important;margin-top:0px!important;padding-top: 0px!important">

                        <v-col cols="12" md="12"
                            style="margin-bottom: 0px!important;padding-bottom: 0px!important;margin-top:0px!important;padding-top: 0px!important">

                            <div id="cont_filtergestore" style="cursor:pointer">
                                <ion-item id="itemGestore"
                                    style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                                    <ion-label style="font-size:12px;color:gray!important;opacity:1;cursor:pointer"
                                        position="floating">Gestore </ion-label>

                                    <ion-select id="filergestore" name="filergestore" class='filergestore'
                                        cancel-Text="Chiudi" done-Text="" :value="gestoreExportXLS"
                                        interface="action-sheet" disabled readonly>

                                        <ion-select-option v-for="item in gestori" :key="item.login"
                                            :value='item.login'> {{
                                                item.name }}</ion-select-option>

                                    </ion-select>
                                </ion-item>
                            </div>

                        </v-col>

                    </v-row>

                    <v-row
                        style="margin-top:0px!important;padding-top: 0px!important;margin-bottom: 0px!important;padding-bottom: 0px!important;">

                        <v-col cols="12" md="12"
                            style="margin-bottom: 0px!important;padding-bottom: 0px!important;margin-top:0px!important;padding-top: 0px!important">

                            <v-select v-model="tipoProgettoExportXLS" :items="tipi_progetto" item-value="id"
                                item-text="nome" label="Tipo Progetto" dense></v-select>


                        </v-col>

                    </v-row>

                    <v-row
                        style="margin-top:0px!important;padding-top: 0px!important;margin-bottom: 0px!important;padding-bottom: 0px!important;">

                        <v-col cols="12" md="12"
                            style="margin-bottom: 0px!important;padding-bottom: 0px!important;margin-top:0px!important;padding-top: 0px!important">

                            <v-select v-model="statoPraticaExportXLS" :items="stati" item-value="id"
                                item-text="descrizione" label="Stato" dense></v-select>


                        </v-col>

                    </v-row>

                    <v-row
                        style="margin-top:0px!important;padding-top: 0px!important;margin-bottom: 0px!important;padding-bottom: 0px!important;">

                        <v-col cols="12" md="12"
                            style="margin-bottom: 0px!important;padding-bottom: 0px!important;margin-top:0px!important;padding-top: 0px!important">

                            <v-select v-model="intestatarioMandatoExportXLS" :items="intestatari_mandati"
                                item-value="id" item-text="descrizione" label="Intestatario Mandato" dense></v-select>


                        </v-col>

                    </v-row>

                    <v-row
                        style="margin-top:0px!important;padding-top: 0px!important;margin-bottom: 0px!important;padding-bottom: 0px!important;">

                        <v-col cols="12" md="12"
                            style="margin-bottom: 0px!important;padding-bottom: 0px!important;margin-top:0px!important;padding-top: 0px!important">

                            <v-select v-model="annoExportXLS" :items="anni_export" item-value="id" item-text="nome"
                                label="Anno" dense></v-select>


                        </v-col>

                    </v-row>

                    <v-row>

                        <div style="font-weight:bold;margin-left:24px">
                            Pagamenti
                        </div>


                    </v-row>

                    <v-row>

                        <div style="display:flex;margin-left:53px;width:85%;margin-top:22px">

                            <div style="width:13%">Tutti</div>
                            <div style="width:13%;text-align:center">Si</div>
                            <div style="width:13%;text-align:center">No</div>
                            <div style="width:24%;text-align:center">No / Parziali</div>
                            <div style="width:20%;text-align:center">Parziali</div>
                            <div style="width:17%;text-align:center"></div>

                        </div>

                    </v-row>

                    <v-row>

                        <div style="display:flex;margin-left:24px;width:85%;margin-top:2px">

                            <v-radio-group v-model="selPagExport" row>

                                <div style="width:13%;transform: translate(20px, -17px);">
                                    <v-radio class="cl-radio" id="ele_tutti" value="1"></v-radio>
                                </div>
                                <div style="width:13%;transform: translate(36px, -17px);">
                                    <v-radio class="cl-radio" id="ele_si" value="2"></v-radio>
                                </div>
                                <div style="width:13%;transform: translate(43px, -17px);">
                                    <v-radio class="cl-radio" id="ele_no" value="3"></v-radio>
                                </div>
                                <div style="width:24%;transform: translate(68px, -17px);">
                                    <v-radio class="cl-radio" id="ele_no_parziali" value="5"></v-radio>
                                </div>
                                <div style="width:20%;transform: translate(77px, -17px);">
                                    <v-radio class="cl-radio" id="ele_parziali" value="4"></v-radio>
                                </div>

                                <div style="width:17%">
                                </div>

                            </v-radio-group>



                        </div>

                    </v-row>



                    <v-row
                        style="margin-bottom: 0px!important;padding-bottom: 0px!important;margin-top:0px!important;padding-top: 0px!important">

                        <v-col cols="12" md="12"
                            style="margin-bottom: 0px!important;padding-bottom: 0px!important;margin-top:0px!important;padding-top: 0px!important">

                            <div id="cont_filtercustomer" style="cursor:pointer">
                                <ion-item id="itemCustomer"
                                    style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                                    <ion-label style="font-size:12px;color:gray!important;opacity:1;cursor:pointer"
                                        position="floating">Clienti </ion-label>

                                    <ion-select id="filercustomer" name="filercustomer" class='filercustomer'
                                        cancel-Text="Chiudi" done-Text="" :value="filterCliente"
                                        interface="action-sheet" disabled readonly>

                                        <ion-select-option v-for="item in aziende" :key="item.companyid"
                                            :value='item.companyid'> {{
                                                item.fld_name }}</ion-select-option>

                                    </ion-select>
                                </ion-item>
                            </div>

                        </v-col>

                    </v-row>



                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-search" contain src="@/assets/btn_cancel3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" @click="btnCancelExportXls" />


                                <v-img alt="" class="btn-confirm-search" contain src="@/assets/btn_confirm3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer" transition="scale-transition"
                                    title="Conferma" @click="btnConfirmExportXls" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


        <div class="contgestori">

            <template>
                <div class="text-center">
                    <v-bottom-sheet v-model="sheetGestoriExport" class="vgestorisheet" style="z-index:999999">
                        <v-sheet class="text-center" height="100vh">
                            <div class="headerSheetGestori" fixed style="position:fixed;">
                                Gestori
                                <v-btn class='closeSheet align_close_sheet' icon
                                    @click="sheetGestoriExport = !sheetGestoriExport">

                                    <v-img alt="Proprietario Logo" class="  " contain src="@/assets/btn_cancel3_emt.png"
                                        max-width="24" max-height="24" style="margin-right:13px"
                                        transition="scale-transition" />

                                </v-btn>

                                <v-toolbar>
                                    <v-text-field hide-details prepend-icon="mdi-magnify" single-line
                                        v-model="searchGestoreExport" id="fldTextSearchGest">
                                    </v-text-field>

                                </v-toolbar>

                            </div>

                            <v-divider></v-divider>

                            <div class="spacer" style="min-height:72px;"></div>

                            <v-flex xs12 sm12>
                                <v-card>

                                    <v-list-item class="text-left" v-for="item in filteredGestoriExport"
                                        :key="item.login" @click="manageClickGestoriExport(item)">

                                        <v-img alt="" src="@/assets/tipo-agila-emt.png" max-width="24"
                                            max-height="24" />

                                        <v-list-item-title class='itemGestore'>{{ item.name }}</v-list-item-title>

                                    </v-list-item>
                                </v-card>
                            </v-flex>
                        </v-sheet>
                    </v-bottom-sheet>
                </div>
            </template>
        </div>




    </div>
</template>


<script>
import apisedioperative from "../utils/sedioperative/apisedioperative";
import apicontrolli from "../utils/controlli/apicontrolli";
import apiotp from "../utils/otp/apiotp";
import apimodalitafatturazione from "../utils/modalitafatturazione/apimodalitafatturazione";

import {
    bus
} from "../main";
import router from ".././router";
import apipratiche from "../utils/pratiche/apipratiche";

import 'datatables.net'

import 'datatables.net-responsive'

import 'datatables.net-fixedheader'

import '../assets/datatables/dataTables.dataTables.css'
import '../assets/datatables/responsive.dataTables.css'
import '../assets/datatables/fixedHeader.dataTables.css'

import $ from 'jquery';

$.fn.numberFormat = function (decimals = 2, decPoint = ',', thousandsSep = '.') {
    return this.each(function () {
        let raw = $(this).text().trim()

        // Converti da "4.468,20" o "4468,2" a "4468.2"
        let val = raw.replace(/\./g, '').replace(',', '.')

        if (!isFinite(val)) return

        let n = parseFloat(val)
        let fixed = n.toFixed(decimals)

        let parts = fixed.split('.')
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep)
        let formatted = parts.join(decPoint)

        $(this).text(formatted)
    })
}


export default {
    destroyed() {
        this.$root.$children[0].bnavbuttons = [];

        bus.$off("bottomIconClickEvent");
    },

    mounted: function () {

        /*eslint-disable no-undef*/

        this.$root.$children[0].checkLogout();

        // used for load users associated to group
        window.$cookies.set("is_load_users_from_group", 1, "9y");

        var pointerVue = this;

        window.myVal = "";

        window.selPratForModFatt = null;

        // filtri
        window.curCompany = window.$cookies.get("filter_company_pratiche");
        window.curSrcText = window.$cookies.get("filter_search_text_pratiche");
        window.curPrjType = window.$cookies.get("filter_tipo_progetto_pratiche");
        window.curCtrType = window.$cookies.get("filter_tipo_controllo_pratiche");
        window.curStatus = window.$cookies.get("filter_stato_pratiche");
        window.curReferente = window.$cookies.get("filter_referente_pratiche");
        window.curGestore = window.$cookies.get("filter_gestore_pratiche");
        window.curPagamento = window.$cookies.get("filter_pagamento_pratiche");
        window.curIntMand = window.$cookies.get("filter_intest_mandato_pratiche");
        window.dateFrom = window.$cookies.get("filter_data_da_pratiche");
        window.dateTo = window.$cookies.get("filter_data_a_pratiche");
        window.curAnno = window.$cookies.get("filter_anno_pratiche");


        window.ddlAziende = null;
        window.ddlTipoControllo = null;
        window.ddlGruppi = null;
        window.ddlPratiche = null;
        window.ddlTipoProgetto = null;
        window.ddlReferenti = null;
        window.ddlGestori = null;
        window.ddlStato = null;


        window.perpage = 100;
        bus.$off("bottomIconClickEvent");

        $(document).ready(
            function () {

                $("body").off();

            }
        );


        $(document).ready(function () {

            $('body').on('click', '#cont_filtergestore', function () {

                console.log(("EVENTO CLICK SELAZIENDA"));

                pointerVue.sheetGestoriExport = true;

            });



            $('body').on('click', '#cont_filtercustomer', function () {

                console.log(("EVENTO CLICK SELAZIENDA"));

                pointerVue.sheetClienti = true;

            });


            $('body').on('click', '.cancelfilters', function () {

                console.log(("EVENTO CLICK SELANNO"));


                window.curCompany = "";
                window.curSrcText = "";
                window.curPrjType = "";
                window.curCtrType = "";
                window.curStatus = "";
                window.curReferente = "";
                window.curGestore = "";
                window.curPagamento = "";
                window.curIntMand = "";
                window.dateFrom = "";
                window.dateTo = "";
                window.curAnno = "";

                window.$cookies.set("filter_company_pratiche", "", "9y");
                window.$cookies.set("filter_search_text_pratiche", "", "9y");
                window.$cookies.set("filter_tipo_progetto_pratiche", "", "9y");
                window.$cookies.set("filter_tipo_controllo_pratiche", "", "9y");
                window.$cookies.set("filter_stato_pratiche", "", "9y");
                window.$cookies.set("filter_referente_pratiche", "", "9y");
                window.$cookies.set("filter_gestore_pratiche", "", "9y");
                window.$cookies.set("filter_pagamento_pratiche", "", "9y");
                window.$cookies.set("filter_intest_mandato_pratiche", "", "9y");
                window.$cookies.set("filter_data_da_pratiche", "", "9y");
                window.$cookies.set("filter_data_a_pratiche", "", "9y");
                window.$cookies.set("filter_anno_pratiche", "", "9y");


                pointerVue.showSpinner = true;
                pointerVue.$root.$children[0].showProgress = true;

                window.table.ajax.reload();

            });










            $('body').on('click', '.seldata', function (event) {
                console.log(event);

                pointerVue.dataDal = null;
                pointerVue.dataAl = null;

                $(".contpopupdateto").show();

                pointerVue.$modal.show('popupDateTo');


            });


            $('body').on('click', '.selintmand', function () {

                console.log(("EVENTO CLICK SELINTMAND"));

                pointerVue.sheetIntMand = true;

            });


            $('body').on('click', '.selanno', function () {

                console.log(("EVENTO CLICK SELANNO"));

                pointerVue.sheetAnno = true;

            });


            $('body').on('click', '.selpagamento', function () {

                console.log(("EVENTO CLICK SELPAGAMENTO"));

                pointerVue.sheetPagamenti = true;

            });




            $('body').on('click', '.selgestore', function () {

                console.log(("EVENTO CLICK SELGESTORE"));

                pointerVue.sheetGestori = true;

                setTimeout(() => {

                    $("#fldTextSearchGest").focus();

                }, 200);

            });

            $('body').on('click', '.selreferente', function () {

                console.log(("EVENTO CLICK SELEREFERENTE"));

                pointerVue.sheetReferenti = true;

            });


            $('body').on('click', '.selazienda', function () {

                console.log(("EVENTO CLICK SELAZIENDA"));

                pointerVue.sheetAziende = true;

                setTimeout(() => {

                    $("#fldTextSearchAzi").focus();

                }, 500);

            });

            $('body').on('click', '.seltipoprogetto', function () {

                console.log(("EVENTO CLICK SELTIPOPROGETTO"));

                pointerVue.sheetProjectType = true;

            });

            $('body').on('click', '.seltipo', function () {

                console.log(("EVENTO CLICK SELTIPO"));

                pointerVue.sheetControlType = true;

            });

            $('body').on('click', '.selstato', function () {

                console.log(("EVENTO CLICK SELSTATO"));

                pointerVue.sheetStatus = true;

            });


            $('body').on('click', '.checkall', function () {


                $(".val_status").prop("checked", $(this).prop("checked"));

                console.log("CHECKALL: ", $(this).prop("checked"));


                if ($(this).prop("checked")) {

                    $("tr").addClass("active-row");

                    $("tr").eq(0).removeClass("active-row");

                }

                if (!$(this).prop("checked")) {

                    $("tr").removeClass("active-row");


                }

                pointerVue.hideShowButtonsSelRow();


            });


            $('body').on('click', '#footer-link', function (event) {
                event.preventDefault();

                const args = [1, true, ['bar', 5], {
                    foo: 'baz'
                }];
                window.flutter_inappwebview.callHandler('openLcHandler', ...args);

                return false;
            });

            $('body').on('click', '#privacy-link', function (event) {
                event.preventDefault();

                const args = [1, true, ['bar', 5], {
                    foo: 'baz'
                }];
                window.flutter_inappwebview.callHandler('openPrivacyHandler', ...args);

                return false;
            });

            $('body').on('click', '#hdtool-link', function (event) {
                event.preventDefault();

                const args = [1, true, ['bar', 5], {
                    foo: 'baz'
                }];
                window.flutter_inappwebview.callHandler('openHdHandler', ...args);

                return false;
            });

            $('body').on('click', '.checkall', function () {


                $(".val_status").prop("checked", $(this).prop("checked"));


            });


        });



        setTimeout(() => {

            this.syncAziende();

        }, 100);

        bus.$on("bottomIconClickEvent", (data) => {
            //this.header = data;
            console.log(data);

            var ids = "";

            switch (data) {

                case "btn_delete":

                    this.getOtpDelete();

                    break;

                case "btn_exit":
                    router.push({
                        path: "/dash"
                    });
                    break;

                case "btn_filter_pag":

                    this.sheetPagamenti = true;

                    break;

                case "btn_add":



                    var v_id = btoa("0") + "l";


                    router.push({
                        path: "/editPratica/" + v_id
                    });




                    break;

                case "btn_edit":

                    ids = "";

                    $(".val_status").each(function (index) {

                        console.log(index);

                        if ($(this).prop("checked")) {

                            if (ids != "") {
                                ids = ids + ",";
                            }
                            ids = ids + $(this).attr("data-id");
                        }

                    });

                    console.log("IDS SEL:", ids);

                    ids = btoa(ids) + "l";

                    router.push({
                        path: "/editPratica/" + ids
                    });



                    break;

                case "btn_back":
                    router.push({
                        path: "/filterSediOperative"
                    });
                    break;

                case "btn_ctr_cond":

                    ids = "";

                    $(".val_status").each(function (index) {

                        console.log(index);

                        if ($(this).prop("checked")) {

                            if (ids != "") {
                                ids = ids + ",";
                            }
                            ids = ids + $(this).attr("data-id");
                        }

                    });

                    console.log("IDS SEL:", ids);

                    ids = btoa(ids) + "l";

                    router.push({
                        path: "/controlliCondizioni/" + ids
                    });


                    break;

                case "btn_del_ctr_cond":

                    this.deleteConditions();


                    break;

                case "btn_export_xls":

                    this.exportXLS();


                    break;


                case "btn_goto_controlli":


                    ids = "";

                    $(".val_status").each(function (index) {

                        console.log(index);

                        if ($(this).prop("checked")) {

                            if (ids != "") {
                                ids = ids + ",";
                            }
                            ids = ids + $(this).attr("data-id");
                        }

                    });

                    console.log("IDS SEL:", ids);

                    ids = btoa(ids) + "l";



                    router.push({
                        path: "/controlli/" + ids + "/MA==l/MA==l/MA==l"
                    });

                    break;


                case "btn_goto_scadenze":


                    ids = "";

                    $(".val_status").each(function (index) {

                        console.log(index);

                        if ($(this).prop("checked")) {

                            if (ids != "") {
                                ids = ids + ",";
                            }
                            ids = ids + $(this).attr("data-id");
                        }

                    });

                    console.log("IDS SEL:", ids);

                    ids = btoa(ids) + "l";

                    router.push({
                        path: "/scadenze/" + ids
                    });


                    break;


                case "btn_doxweb":

                    this.doxweb();

                    break;



                case "btn_goto_mod_fatt":

                    // ids = "";

                    // $(".val_status").each(function (index) {

                    //     console.log(index);

                    //     if ($(this).prop("checked")) {

                    //         if (ids != "") {
                    //             ids = ids + ",";
                    //         }
                    //         ids = ids + $(this).attr("data-id");
                    //     }

                    // });

                    // console.log("IDS SEL:", ids);

                    // ids = btoa(ids) + "l";

                    // router.push({
                    //     path: "/modalitaFatturazione/" + ids
                    // });

                    this.goToModalitaFatturazione();


                    break;

                case "btn_view":

                    ids = "";

                    $(".val_status").each(function (index) {

                        console.log(index);

                        if ($(this).prop("checked")) {

                            if (ids != "") {
                                ids = ids + ",";
                            }
                            ids = ids + $(this).attr("data-id");
                        }

                    });

                    console.log("IDS SEL:", ids);

                    ids = btoa(ids) + "l";

                    router.push({
                        path: "/vediPratica/" + ids
                    });



                    break;


                default:
                    break;

            }
        });


        this.setupButtonsGrid();

        window.start_ = 0;

        //var pointerVue = this;


        pointerVue.setupGrid();

        this.hideShowButtons(false);

        setTimeout(() => {

            $('thead th:first div span').addClass('no-before');


            $('.dt-type-numeric').removeClass('dt-type-numeric');
            $('.dt-type-date').removeClass('dt-type-date');


        }, 500);

    },
    data: () => ({

        sheetGestoriExport: false,
        searchGestoreExport: "",

        anni_export: [],

        annoExportXLS: "",

        intestatari_mandati: [],

        intestatarioMandatoExportXLS: "",

        statoPraticaExportXLS: "",

        tipi_progetto: [],

        tipoProgettoExportXLS: "",

        gestoreExportXLS: "",

        selPagExport: "5",

        sheetClienti: false,

        filterCliente: "",

        selPag: "",

        annoExportXls: "",

        textSearchExportXls: "",


        valueOtpDelete: "",

        sheetAnno: false,

        anni: [{ id: "", nome: "Tutti" }, { id: "2025", nome: "2025" }, { id: "2024", nome: "2024" }, { id: "2023", nome: "2023" }, { id: "2022", nome: "2022" }, { id: "2021", nome: "2021" }, { id: "2020", nome: "2020" }, { id: "2019", nome: "2019" }, { id: "2018", nome: "2018" }, { id: "2017", nome: "2017" }, { id: "2016", nome: "2016" }, { id: "2015", nome: "2015" }],

        sheetIntMand: false,

        intestatario_mandato: [],

        sheetPagamenti: false,

        stati_pagamento: [],

        gestori: [],

        searchGestore: "",

        sheetGestori: false,

        sheetReferenti: false,

        sheetStatus: false,

        sheetProjectType: false,

        sheetControlType: false,

        sheetAziende: false,
        search: "",

        textSearch: "",

        aziende: [],

        projectType: [],

        controlTypeTemp: [],

        controlType: [],


        referentiTemp: [],

        referenti: [],

        // stati: [{ id: "", nome: "Tutti" }, { id: "Y", nome: "Si" }, { id: "N", nome: "No" }, { id: "1", nome: "NA" }, { id: "2", nome: "WIP" }],

        stati: [],

        showPicker: false,
        showPicker2: false,

        dataDal: null,
        dataAl: null,

        profile: {},
        valid: true,
        initials: "",
        namesurname: "",
        iban: "",
        cellulare: "",
        codicefiscale: "",
        codicefiscaleRules: [
            (v) => !!v || "Codice fiscale is required",
            (v) =>
                (v && v.length <= 16) ||
                "Codice fiscale must be less than 16 characters",
        ],
        cellulareRules: [
            (v) => !!v || "Phone number is required",
            (v) =>
                (v && v.length <= 30) || "Phone number must be less than 15 characters",
        ],
        genRules: [(v) => !!v || "Field required"],
        ibanRules: [
            (v) => !!v || "Iban is required",
            (v) => (v && v.length <= 30) || "Iban must be less than 30 characters",
        ],
        email: "",
        emailRules: [
            (v) => !!v || "E-mail is required",
            (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
        ],
        select: null,
        items: ["Item 1", "Item 2", "Item 3", "Item 4"],
        checkbox: false,
    }),

    computed: {

        filteredAziende() {
            return _.orderBy(this.aziende.filter(item => {
                if (!this.search) return this.aziende;
                return (item.fld_name.toLowerCase().includes(this.search.toLowerCase()));
            }), 'headline')


        },

        filteredGestori() {
            return _.orderBy(this.gestori.filter(item => {
                if (!this.searchGestore) return this.gestori;
                return (item.name.toLowerCase().includes(this.searchGestore.toLowerCase()));
            }), 'headline')


        },


        filteredGestoriExport() {
            return _.orderBy(this.gestori.filter(item => {
                if (!this.searchGestoreExport) return this.gestori;
                return (item.name.toLowerCase().includes(this.searchGestoreExport.toLowerCase()));
            }), 'headline')


        },



    },


    methods: {


        goToModalitaFatturazione: async function () {

            var that = this;

            var ids = "";

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {

                    if (ids != "") {
                        ids = ids + ",";
                    }
                    ids = ids + $(this).attr("data-id");
                }

            });

            console.log("IDS SEL:", ids);

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;


            var response = await apimodalitafatturazione.getDefaultValueModFatt(
                ids
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from getDefaultValueModFatt", res);

                setTimeout(() => {

                    window.selPratForModFatt = res.data;

                    setTimeout(() => {

                        ids = btoa(ids) + "l";

                        router.push({
                            path: "/modalitaFatturazione/" + ids
                        });

                    }, 300);

                }, 300);




            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile salvare i dati");
                console.log("response", response);

            }

            );

        },

        btnCancelExportXls: function () {

            this.$modal.hide('popupExportXls');


        },

        btnConfirmExportXls: async function () {



            this.$modal.hide('popupExportXls');

            var that = this;



            console.log("PAGAM: ", that.selPagExport);

            var v_pag = "";

            if (that.selPagExport != 1) {

                if (that.selPagExport == 2) { // pagati si

                    v_pag = 3;

                }

                if (that.selPagExport == 3) { // pagati no

                    v_pag = 1;

                }

                if (that.selPagExport == 4) { // pagati parziali

                    v_pag = 2;

                }


                if (that.selPagExport == 5) { //no / pagati parziali

                    v_pag = 4;

                }

            }






            var v_token = window.$cookies.get("token");


            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;


            var response = await apipratiche.exportXLS(
                v_token,
                that.filterCliente,
                that.tipoProgettoExportXLS,
                that.statoPraticaExportXLS,
                that.textSearchExportXls,
                "",
                that.gestoreExportXLS,
                v_pag,
                that.intestatarioMandatoExportXLS,
                "",
                "",
                that.annoExportXLS
            ).then(async (res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from exportXLS", res);


                var full_path = res.data.FullPath;
                var file_path = res.data.ValUrl;
                var a = document.createElement('A');
                a.href = file_path;
                a.target = "_blank";
                a.download = file_path.substr(file_path.lastIndexOf('/') + 1);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);


                var response3 = await apitimesheet.deleteFile(

                    full_path

                ).then(async (res3) => {

                    console.log("res from deleteFile", res3);

                    console.log(response3);

                    this.showSpinner = false;







                }).catch(err3 => {

                    console.log(response2);
                    console.log(err3);

                    that.$root.$children[0].showProgress = false;
                    console.log(err);
                    var msg = err3.response.data.Error;

                    that.$swal({
                        icon: "error",
                        text: msg,
                        showConfirmButton: false,
                        timer: 8000
                    });
                    console.log("Errori", "Non è stato possibile eliminare i dati");
                    console.log("response", response);

                }

                );




            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );

        },



        getOtpDelete: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");

            var ids = "";

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {

                    if (ids != "") {
                        ids = ids + ",";
                    }
                    ids = ids + $(this).attr("data-id");
                }

            });

            console.log("IDS SEL:", ids);


            window.myVal = "";

            that.valueOtpDelete = "";

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apiotp.generateOTPAndSendMail(
                v_token,
                'emt',
                'elimina_pratica',
                ids
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from generateOTPAndSendMail", res);

                window.myVal = res.data.Result;


                setTimeout(() => {

                    $(".contpopupotpdelete").show();

                    this.$modal.show('popupOtpDelete');

                    setTimeout(() => {

                        $("#fldValueOtpDelete").focus();

                    }, 300);


                }, 200);





            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );






        },


        btnCancelOtpDelete: function () {

            this.$modal.hide('popupOtpDelete');


        },

        btnConfirmOtpDelete: function () {


            if (this.valueOtpDelete != "") {

                console.log("OTP INP: ", this.valueOtpDelete);
                console.log("ENC OTP INP: ", btoa(this.valueOtpDelete));

                if (window.myVal == btoa(this.valueOtpDelete)) {

                    this.$modal.hide('popupOtpDelete');

                    this.deleteRow();

                }
                else {

                    this.$swal({
                        icon: "error",
                        text: "Valore OTP non corretto",
                        showConfirmButton: false,
                        timer: 2000
                    });


                }



            }
            else {

                this.$swal({
                    icon: "error",
                    text: "Specificare un  valore dell'OTP",
                    showConfirmButton: false,
                    timer: 2000
                });

            }



        },



        viewCancelFiltri: function () {

            var cancelFiltri = 0;


            if (window.curCompany != "") {
                if (window.curCompany != null) {
                    cancelFiltri = 1;
                }
            }

            if (window.curSrcText != "") {
                if (window.curSrcText != null) {
                    cancelFiltri = 1;
                }
            }

            if (window.curPrjType != "") {
                if (window.curPrjType != null) {
                    cancelFiltri = 1;
                }
            }

            if (window.curCtrType != "") {
                if (window.curCtrType != null) {
                    cancelFiltri = 1;
                }
            }

            if (window.curStatus != "") {
                if (window.curStatus != null) {
                    cancelFiltri = 1;
                }
            }

            if (window.curReferente != "") {
                if (window.curReferente != null) {
                    cancelFiltri = 1;
                }
            }

            if (window.curGestore != "") {
                if (window.curGestore != null) {
                    cancelFiltri = 1;
                }
            }

            if (window.curPagamento != "") {
                if (window.curPagamento != null) {
                    cancelFiltri = 1;
                }
            }

            if (window.curIntMand != "") {
                if (window.curIntMand != null) {
                    cancelFiltri = 1;
                }
            }

            if (window.dateFrom != "") {
                if (window.dateFrom != null) {
                    cancelFiltri = 1;
                }
            }

            if (window.dateTo != "") {
                if (window.dateTo != null) {
                    cancelFiltri = 1;
                }
            }

            if (window.curAnno != "") {
                if (window.curAnno != null) {
                    cancelFiltri = 1;
                }
            }

            console.log("CANCEL FILTRI: ", cancelFiltri);

            if (cancelFiltri == 0) {

                $((".cancelfilters")).hide();

            }

            if (cancelFiltri == 1) {

                $((".cancelfilters")).show();

            }


        },


        btnCancelDate: function () {

            this.$modal.hide('popupDateTo');

        },

        btnResetDate: function () {

            this.dataDal = null;
            this.dataAl = null;

        },

        btnConfirmDate: function () {

            window.dateFrom = this.dataDal;
            window.dateTo = this.dataAl;

            this.$modal.hide('popupDateTo');


            this.hideShowButtons(false);

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();




        },

        setTipoControlli: function (id_tipo_progetto) {

            console.log("AZI SEL 2: ", id_tipo_progetto);

            console.log("DIP TMP: ", this.controlTypeTemp);

            var TipoControlli = [];

            if (id_tipo_progetto != "") {

                TipoControlli.push({
                    id: "",
                    descrizione: "Tutti"
                });

                for (var i = 0; i < this.controlTypeTemp.length; i++) {

                    if (parseInt(this.controlTypeTemp[i].tipo_progetto_id) == parseInt(id_tipo_progetto)) {

                        TipoControlli.push({
                            id: this.controlTypeTemp[i].id,
                            descrizione: this.controlTypeTemp[i].descrizione
                        });

                    }

                }


            }


            console.log("DIP SEL: ", TipoControlli);

            this.controlType = TipoControlli;

        },



        setReferenti: function (id_azienda) {

            console.log("AZI SEL: ", id_azienda);

            console.log("REFS TMP: ", this.referentiTemp);

            var Referenti = [];

            if (id_azienda != "") {

                Referenti.push({
                    id: "",
                    referente: "Tutti"
                });

                for (var i = 0; i < this.referentiTemp.length; i++) {

                    if (parseInt(this.referentiTemp[i].companyid) == parseInt(id_azienda)) {

                        Referenti.push({
                            id: this.referentiTemp[i].id,
                            referente: this.referentiTemp[i].referente
                        });

                    }

                }


            }


            console.log("REFS SEL 2: ", Referenti);

            this.referenti = Referenti;

        },



        filterReferente: function (refId) {


            console.log("REF SEL: ", refId);

            this.sheetReferenti = false;

            window.curReferente = refId;

            window.$cookies.set("filter_referente_pratiche", refId, "9y");


            this.hideShowButtons(false);

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();

        },



        filterPagamento: function (pagId) {


            console.log("PAG SEL: ", pagId);

            this.sheetPagamenti = false;

            window.curPagamento = pagId;

            window.$cookies.set("filter_pagamento_pratiche", pagId, "9y");


            this.hideShowButtons(false);

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();

        },




        filterIntMand: function (mandId) {


            console.log("INT MAND SEL: ", mandId);

            this.sheetIntMand = false;

            window.curIntMand = mandId;

            window.$cookies.set("filter_intest_mandato_pratiche", mandId, "9y");


            this.hideShowButtons(false);

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();

        },


        filterAnno: function (anno) {


            console.log("ANNO SEL: ", anno);

            this.sheetAnno = false;

            window.curAnno = anno;

            window.$cookies.set("filter_anno_pratiche", anno, "9y");

            this.hideShowButtons(false);

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();

        },



        filterStatus: function (statusId) {


            console.log("STATUS SEL: ", statusId);

            this.sheetStatus = false;

            window.curStatus = statusId;

            window.$cookies.set("filter_stato_pratiche", statusId, "9y");


            this.hideShowButtons(false);

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();

        },

        filterControlType: function (ctrTypeId) {


            console.log("CTR TYPE SEL: ", ctrTypeId);

            this.sheetControlType = false;

            window.curCtrType = ctrTypeId;

            this.hideShowButtons(false);

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();

        },





        filterProjectType: function (prjTypeId) {


            console.log("PRJ TYPE SEL: ", prjTypeId);

            this.sheetProjectType = false;

            window.curPrjType = prjTypeId;

            window.$cookies.set("filter_tipo_progetto_pratiche", prjTypeId, "9y");

            this.hideShowButtons(false);

            //this.setTipoControlli(prjTypeId);

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();

        },

        syncAziende: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apicontrolli.initDDL(
                v_token
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from initDDL", res);

                try {

                    this.aziende = res.data.filtro_aziende;

                    this.projectType = res.data.filtro_tipo_proj;

                    this.controlTypeTemp = res.data.tipo_controllo;

                    this.stati = res.data.stato_pratiche;

                    this.referentiTemp = res.data.referenti;

                    this.gestori = res.data.gestori;

                    this.stati_pagamento = res.data.stato_pagamento;

                    this.intestatario_mandato = res.data.intestatario_mandato;


                    window.ddlAziende = res.data.company;

                    window.ddlTipoControllo = res.data.tipo_controllo;

                    window.ddlGruppi = res.data.gruppi;

                    window.ddlPratiche = res.data.pratiche;

                    window.ddlTipoProgetto = res.data.tipo_progetto;

                    window.ddlReferenti = res.data.referenti_edit;

                    window.ddlGestori = res.data.gestori_edit;

                    window.ddlStato = res.data.stato_pratiche_edit;


                } catch (error) {
                    console.log(error);
                }

            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("ERrori", "Non è stato possibile caricare i dati");
                console.log("response", response);

            }

            );

        },


        manageClickGestoriExport: async function (gestore) {

            console.log("GEST SEL: ", gestore);

            this.sheetGestoriExport = false;

            this.gestoreExportXLS = gestore.login;


        },

        manageClickGestori: async function (gestore) {

            console.log("GEST SEL: ", gestore);

            this.sheetGestori = false;

            window.curGestore = gestore.login;

            window.$cookies.set("filter_gestore_pratiche", gestore.login, "9y");


            this.hideShowButtons(false);

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();


        },

        manageClickClienti: async function (azienda) {

            console.log("AZI SEL: ", azienda);

            this.sheetClienti = false;

            this.filterCliente = azienda.companyid;


        },


        manageClickAziende: async function (azienda) {

            console.log("AZI SEL: ", azienda);

            this.sheetAziende = false;

            window.curCompany = azienda.companyid;

            // if (window.curCompany == "") {
            //     window.curReferente = "";
            // }

            window.curReferente = "";

            window.$cookies.set("filter_company_pratiche", window.curCompany, "9y");
            window.$cookies.set("filter_referente_pratiche", window.curReferente, "9y");


            this.setReferenti(azienda.companyid);

            this.hideShowButtons(false);

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();


        },


        hideShowButtonsSelRow: function () {

            var tot = 0;

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {

                    tot = tot + 1;

                }


            });

            setTimeout(() => {

                var pulsantis = [];



                if (tot == 0) {

                    pulsantis.push({
                        text: "Add",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/xbox-cross-emt.png",
                        link: "/settings",
                        id: "btn_add",
                        disabled: false,
                        title: "Aggiungi",
                        width: 30

                    });


                    pulsantis.push({
                        text: "Esporta XLS",
                        icon: "mdi-arrow-left",
                        image: "https://app.emtool.eu/public/_lib/img/export-xls-emt.png",
                        link: "/confOrariChoice",
                        id: "btn_export_xls",
                        disabled: false,
                        title: "Esporta Excel",
                        width: 30
                    });



                }







                if (tot == 1) {

                    pulsantis.push({
                        text: "Edit",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/icon_edit_emt.png",
                        link: "/info",
                        id: "btn_edit",
                        disabled: false,
                        title: "Modifica",
                        width: 30
                    });

                    pulsantis.push({
                        text: "Edit",
                        icon: "mdi-home-circle",
                        image: this.getUrlDomain("public/_lib/img/view_emt.png"),
                        link: "/info",
                        id: "btn_view",
                        disabled: false,
                        title: "Vedi",
                        width: 40
                    });

                    pulsantis.push({
                        text: "Edit",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/controlli-emt.png",
                        link: "/info",
                        id: "btn_goto_controlli",
                        disabled: false,
                        title: "Controlli",
                        width: 30
                    });

                    pulsantis.push({
                        text: "Edit",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/scadenze-emt.png",
                        link: "/info",
                        id: "btn_goto_scadenze",
                        disabled: false,
                        title: "Scadenze",
                        width: 30
                    });

                    pulsantis.push({
                        text: "Edit",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/mod-fatturazione-emt.png",
                        link: "/info",
                        id: "btn_goto_mod_fatt",
                        disabled: false,
                        title: "Modalità Fatturazione",
                        width: 30
                    });

                    pulsantis.push({
                        text: "Edit",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/doxweb-emt.png",
                        link: "/info",
                        id: "btn_doxweb",
                        disabled: false,
                        title: "Doxweb",
                        width: 22
                    });


                    // pulsantis.push({
                    //     text: "Edit",
                    //     icon: "mdi-home-circle",
                    //     image: "https://app.emtool.eu/public/_lib/img/icon-controls-conditions-emt.png",
                    //     link: "/info",
                    //     id: "btn_ctr_cond",
                    //     disabled: false,
                    //     title: "Condizioni",
                    //     width: 30
                    // });




                }

                if (tot > 0) {


                    pulsantis.push({
                        text: "Delete",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/icon_delete_emt.png",
                        link: "/info",
                        id: "btn_delete",
                        disabled: false,
                        title: "Elimina",
                        width: 30
                    });

                    // pulsantis.push({
                    //     text: "Edit",
                    //     icon: "mdi-home-circle",
                    //     image: "https://app.emtool.eu/public/_lib/img/icon-eraser-emt.png",
                    //     link: "/info",
                    //     id: "btn_del_ctr_cond",
                    //     disabled: false,
                    //     title: "Elimina Condizioni",
                    //     width: 30
                    // });

                }

                // pulsantis.push({
                //     text: "Esporta XLS",
                //     icon: "mdi-arrow-left",
                //     image: "https://app.emtool.eu/public/_lib/img/icon-export-xls-emt.png",
                //     link: "/confOrariChoice",
                //     id: "btn_export_xls",
                //     disabled: false,
                //     title: "Esporta Excel",
                //     width: 30
                // });


                // pulsantis.push({
                //     text: "Indietro",
                //     icon: "mdi-arrow-left",
                //     image: "https://app.emtool.eu/public/_lib/img/back-emt.png",
                //     link: "/confOrariChoice",
                //     id: "btn_back",
                //     disabled: false,
                //     title: "Indietro",
                //     width: 30
                // });



                this.$root.$children[0].bnavbuttons = pulsantis;



            }, 100);



        },


        btnCancelSearch: function () {

            this.$modal.hide('popupSearch');

        },


        btnConfirmSearch: function () {

            console.log("ok");

            window.curSrcText = this.textSearch;

            window.$cookies.set("filter_search_text_pratiche", this.textSearch, "9y");

            this.$modal.hide('popupSearch');

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();

        },


        getUrlDomain: function (nome_metodo) {

            let result = "";

            if (location.hostname == "localhost") {
                result = location.protocol + "//emtool.local/";
            }

            if (location.hostname != "localhost") {

                result = location.protocol + "//" + location.hostname + "/";

            }

            return result + nome_metodo;

        },

        getUrlApiDomain: function (nome_metodo) {

            let result = "";

            if (location.hostname == "localhost") {
                result = location.protocol + "//emtool.local/";
            }

            if (location.hostname != "localhost") {

                result = location.protocol + "//" + location.hostname + "/";

            }

            return result + "api/doxweb/" + nome_metodo;

        },

        getUrlPublicApiDomain: function (nome_metodo) {

            let result = "";

            if (location.hostname == "localhost") {
                result = location.protocol + "//emtool.local/";
            }

            if (location.hostname != "localhost") {

                result = location.protocol + "//" + location.hostname + "/";

            }

            return result + "public/api/doxweb/" + nome_metodo;

        },

        setupGrid: function () {





            var filtri = `<img src='/emt/img/aziende-emt.png' style='border:0!important;' class='selazienda' title='Aziende' /><img src='/emt/img/referenti_emt.png' style='border:0!important;' class='selreferente' title='Referente' /><img src='/emt/img/tipo-agila-emt.png' style='border:0!important;' class='selgestore' title='Gestore' /><img src='/emt/img/tipo-progetto-agila-emt.png' style='border:0!important;' class='seltipoprogetto' title='Tipo Progetto' /><img src='/emt/img/filtro-stato-emt.png' style='border:0!important;' class='selstato' title='Stato' /><img src='/emt/img/filtro-pagamento-emt.png' style='border:0!important;' class='selpagamento' title='Pagamento' /><img src='/emt/img/tipo-agila-emt.png' style='border:0!important;' class='selintmand' title='Intestatario Mandato' /><img src='/emt/img/calendario-giorni-emt.png' style='border:0!important;' class='selanno' title='Anno' /><img src='/emt/img/delete_filters_emt.png' style='border:0!important;' class='cancelfilters' title='Cancella Filtri Applicati' />`;





            var pointerVue = this;



            const date = new Date().toJSON().slice(0, 10)



            $(document).ready(function () {

                var v_token = window.$cookies.get("token");

                console.log("TOKEN: ", v_token);


                window.columns = [

                    {
                        data: 'sel_row',
                        orderable: false,
                        name: 'sel_row',
                        width: '0.1%'
                    },

                    {
                        data: 'row_id',
                        orderable: false,
                        searchable: false,
                        name: '',
                        width: '0.1%',
                    },

                    {
                        data: 'codice_univoco',
                        orderable: true,
                        name: 'codice_univoco',
                        width: '2%'
                    },


                    {
                        data: 'nome',
                        orderable: true,
                        name: 'nome',
                        width: '4%'
                    },

                    {
                        data: 'fld_name',
                        orderable: true,
                        name: 'fld_name',
                        width: '4%'
                    },

                    {
                        data: 'referente',
                        orderable: true,
                        name: 'referente',
                        width: '4%'
                    },

                    {
                        data: 'name',
                        orderable: true,
                        name: 'name',
                        width: '4%'
                    },

                    {
                        data: 'nome_tipo_progetto',
                        orderable: true,
                        name: 'nome_tipo_progetto',
                        width: '4%'
                    },

                    {
                        data: 'data_inoltro_domanda',
                        orderable: true,
                        name: 'data_inoltro_domanda',
                        width: '4%'
                    },

                    {
                        data: 'note',
                        orderable: true,
                        name: 'note',
                        width: '4%'
                    },

                    {
                        data: 'desc_status',
                        orderable: true,
                        name: 'desc_status',
                        width: '4%'
                    },

                    {
                        data: 'fatt_bozza',
                        orderable: false,
                        name: 'fatt_bozza',
                        width: '4%'
                    },

                    {
                        data: 'pag_fatt',
                        orderable: false,
                        name: 'pag_fatt',
                        width: '4%'
                    },

                    {
                        data: 'contributo',
                        orderable: true,
                        name: 'contributo',
                        width: '6%'
                    },

                    {
                        data: 'investimento',
                        orderable: true,
                        name: 'investimento',
                        width: '5%'
                    },

                    {
                        data: 'previsionale',
                        orderable: true,
                        name: 'previsionale',
                        width: '6%'
                    },


                    {
                        data: 'imp_fatt_mod_fatt',
                        orderable: true,
                        name: 'imp_fatt_mod_fatt',
                        width: '6%'
                    },


                    {
                        data: 'rim_fatt_mod_fatt',
                        orderable: true,
                        name: 'rim_fatt_mod_fatt',
                        width: '6%'
                    },



                    {
                        data: 'mandato',
                        orderable: false,
                        name: 'mandato',
                        width: '4%'
                    },

                    {
                        data: 'load_in_doxweb',
                        orderable: false,
                        name: 'load_in_doxweb',
                        width: '4%'
                    },

                    {
                        data: 'nickname_doxweb',
                        orderable: true,
                        name: 'nickname_doxweb',
                        width: '4%'
                    },



                ];



                window.table = $('#myTable').DataTable({
                    // dom: "<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'f>>" +
                    //     "<'rows colcontTable'<'col-sm-12 'tr>>" +
                    //     "<'row'<'col-sm-12 col-ok  col-md-12'i><'col-sm-12 col-ok-2  col-md-12'p>>",
                    "pagingType": "simple",
                    responsive: true,
                    "pageLength": window.perpage,

                    processing: false,
                    paging: false,
                    serverSide: false,


                    ajax: {
                        url: pointerVue.getUrlDomain("EmtAgilaGetPraticheApi") + '?username=' + v_token,
                        data: function (valori) {

                            console.log("VALORI:", valori);

                            try {
                                window.table.clear().draw();

                            } catch (error) {
                                console.log(error);
                            }

                            window.start_ = window.perpage;

                            valori.start_ = 0;
                            valori.length_ = window.perpage;



                            valori.curSrcText = window.curSrcText;
                            valori.curCompany = window.curCompany;
                            valori.curPrjType = window.curPrjType;
                            valori.curCtrType = window.curCtrType;
                            valori.curStatus = window.curStatus;
                            valori.curReferente = window.curReferente;
                            valori.curGestore = window.curGestore;
                            valori.curPagamento = window.curPagamento;
                            valori.curIntMand = window.curIntMand;
                            valori.dateFrom = window.dateFrom;
                            valori.dateTo = window.dateTo;
                            valori.curAnno = window.curAnno;


                            window.valori = valori;
                            return valori;

                        }

                    },



                    language: {

                        lengthMenu: `<label>Mostra<select name="myTable_length" aria-controls="myTable" class="custom-select custom-select-sm form-control-sm"><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option><option value="-1">Tutti</option></select>Inserimenti</label>`,

                        paginate: {
                            next: "<img style='height:15px;border:none' src='https://app.emtool.eu/_lib/img/next2.png'>",
                            previous: "<img style='height:15px;border:none' src='https://app.emtool.eu/_lib/img/previous2.png'>"
                        },

                        "sSearch": " ",
                        processing: '<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66"><circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>'
                    },
                    "info": "",
                    "fnDrawCallback": function (oSettings) {

                        console.log(oSettings);

                        $("body").tooltip({
                            selector: '[data-toggle="tooltip"]'
                        });
                    },

                    columns: window.columns,

                    "initComplete": function (settings) {

                        console.log(settings);

                        $("#myTable_wrapper").show();
                        $(".spin").hide();

                    },
                    "drawCallback": function (settings) {

                        console.log(settings);

                        $(".spin").hide();

                        setTimeout(function () {

                            pointerVue.showSpinner = false;
                            pointerVue.$root.$children[0].showProgress = false;

                        }, 1000);

                        pointerVue.viewCancelFiltri();

                        var elements = $('.datetimeBook');
                        elements.each(function () {

                            var id = $(this).data("id");
                            (this).pickerOptions = {
                                buttons: [{
                                    text: 'Cancel',
                                    role: 'cancel',
                                    cssClass: 'switch-btn-cancel',
                                },
                                {
                                    text: 'Done',
                                    cssClass: 'switch-btn-done',
                                    handler: columns => {
                                        console.log("ore minuti id", columns.hour.text, columns.minute.text, id);
                                        var valore = columns.hour.text + ":" + columns.minute.text;

                                        console.log(valore);

                                        $.ajax({
                                            url: pointerVue.getUrlDomain("updateHour"),
                                            data: {
                                                "id": id,
                                                "hour": valore,
                                                "v_user": "ZmFnb3N0b25p"
                                            },
                                            success: function () { }
                                        });

                                    }
                                },
                                ],
                            };
                        });

                        setTimeout(function () {

                            //   $("#myTable_filter").width($("#myTable").width());

                        }, 300);

                        var selects = $('.selectstatus');
                        selects.each(function () {
                            var id = $(this).data("id");

                            console.log("ciaone", $(this).data("id"));

                            $(this).on("ionChange", function (opt) {

                                console.log(opt);

                                $(".spin").show();
                                $.ajax({
                                    url: pointerVue.getUrlDomain("updateStatus"),
                                    data: {
                                        "id": id,
                                        "hour": this.value,
                                        "v_user": "ZmFnb3N0b25p"
                                    },
                                    success: function () {
                                        window.table._fnDraw();
                                    }
                                });

                            });

                        });

                        $(".downloadspinner").hide();


                        $('.p_contributo, .p_investimento, .p_previsionale, .p_imp_fatt, .p_rim_fatt').numberFormat(2, ',', '.');




                        setTimeout(() => {



                            $('.dt-type-numeric').removeClass('dt-type-numeric');
                            $('.dt-type-date').removeClass('dt-type-date');


                        }, 500);







                    }

                });




                //Events
                //START SETUP
                function throttle(f, delay) {
                    var timer = null;
                    return function () {
                        var context = this,
                            args = arguments;
                        clearTimeout(timer);
                        timer = window.setTimeout(function () {
                            f.apply(context, args);
                        },
                            delay || 500);
                    };
                }
                window.loading = 0;
                $("div.dataTables_filter input").unbind();
                $('div.dataTables_filter input').keyup(throttle(function () {
                    window.table.ajax.reload();

                }));
                $('#myTable_wrapper').on('scroll', function () {
                    if ($(this).scrollTop() + $(this).innerHeight() + 50 >= $(this)[0].scrollHeight) {
                        if (window.loading == 0) {
                            $(".spin").show();

                            setTimeout(() => {

                                $(".spin").hide();

                            }, 800);


                            var valori = window.valori;
                            valori.start_ = window.start_;

                            $.ajax({
                                url: pointerVue.getUrlDomain("EmtAgilaGetPraticheApi") + '?username=' + v_token,
                                data: window.valori,
                                success: function (data) {
                                    //  $(".spin").hide();
                                    window.loading = 0;
                                    window.start_ += window.perpage;

                                    for (let [index, val] of data.data.entries()) {
                                        console.log(index, val);
                                        window.table.row.add(val).draw(false);
                                        //  window.dataset.push(val);
                                    }
                                    console.log(data.data);
                                },
                            });
                        }
                        window.loading = 1;
                    }
                });
                //END

                var search = $(".dataTables_length").clone(true);
                search.attr("id", "final_search");
                $(".table_paginate").prepend(search);

                $("#myTable_wrapper .dt-layout-row").first().find("div").remove();

                $("#myTable_wrapper .dt-layout-end").remove();

                $("#myTable_wrapper .dt-layout-row").first().prepend(`
                <div class="cont_buttons">

                    <div class="text_title">Pratiche</div>

                    <div class="content_wrap_buttons"><div class="wrap_buttons">
                        ` + filtri + `
                        
                        </div></div>



                    


                </div>
                <div><img src='/emt/img/cerca-emt.png' style='border:0!important;' class='selricerca' title='Ricerca' /></div>

            `);

                $(".selricerca").on("click", function (opt) {
                    console.log(opt);

                    pointerVue.textSearch = "";

                    $(".contpopupsearch").show();

                    pointerVue.$modal.show('popupSearch');

                    setTimeout(() => {

                        $("#fldSearch").focus();

                    }, 200);

                });

                $('body').on('click', '.paginate_button', function () {
                    $(".spin").show();

                });

                $('body').on('click', '.refreshButton', function () {

                    $(".spin").show();
                    window.table._fnDraw();

                });

                $('body').on('click', '.cont_agila_pratiche tr', function () {


                    var row_data = window.table.row(this).data();

                    if (row_data != null) {


                        var last_id_sel = $("tr.active-row").find(".id_row").attr("data-id");

                        var id_sel = $(this).find(".id_row").attr("data-id");

                        var set_cls_active = 0;

                        if (last_id_sel == "undefined") {
                            set_cls_active = 1;
                        } else {
                            if (last_id_sel != id_sel) {
                                set_cls_active = 1;
                            }
                        }

                        console.log("ROM IS ACTIVE: ", set_cls_active);



                        console.log("THIS: ", this);

                        var hasClassActive = $(this).hasClass("active-row");

                        if (hasClassActive) {

                            console.log("ACTIVE-ROW");

                            $(this).find(".val_status").prop("checked", false);

                            $(this).removeClass("active-row");

                        }

                        if (!hasClassActive) {

                            console.log("NOT ACTIVE-ROW");

                            $(this).find(".val_status").prop("checked", true);

                            $(this).addClass("active-row");



                        }

                        window.id_par_sel = $("tr.active-row").find(".id_row").attr("data-id");

                        if (window.id_par_sel == undefined) {
                            window.id_par_sel = id_sel;
                        }

                        console.log("ID SELECTED: ", window.id_par_sel);

                        pointerVue.hideShowButtonsSelRow();


                    }



                });

                // }

                //setup ionic calendar top
                setTimeout(function () {

                    $("body").on("ionChange", ".dateBook", function (opt) {

                        console.log(opt);
                        var date = this.value;
                        //var dateMysql = date.toJSON().slice(0, 19).replace('T', ' ')   ;
                        dateMysql = date.substr(0, 10);

                        console.log(dateMysql);

                        $.ajax({
                            url: "{{ route('smartbook.updateDate') }}",
                            data: {
                                "id": $(this).data("id"),
                                "date": dateMysql
                            },
                        });

                    });

                    $(".selectstatusall").on("ionChange", function (opt) {
                        console.log(opt);
                        $(".spin").show();
                        window.curStatus = this.value;

                        window.table.fnPageChange(0);
                        window.table._fnDraw();

                    });

                    $(".selectpianiall").on("ionChange", function (opt) {
                        console.log(opt);
                        $(".spin").show();
                        window.curPiano = this.value;

                        window.table.fnPageChange(0);
                        window.table._fnDraw();

                    });

                    window.currDay = date;
                    window.currDayTo = date;

                }, 600);

                window.parentiAddedEvents = true;

            });

        },

        hideShowButtons: async function (v_enable) {

            var ids = "";

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {


                    if (ids != "") {
                        ids = ids + ",";
                    }
                    ids = ids + $(this).attr("data-id");
                }

            });

            setTimeout(() => {

                var pulsantis = [];

                if (v_enable == false) {




                    pulsantis.push({
                        text: "Add",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/xbox-cross-emt.png",
                        link: "/settings",
                        id: "btn_add",
                        disabled: false,
                        title: "Aggiungi",
                        width: 30
                    });

                    if (ids != "") {

                        pulsantis.push({
                            text: "Delete",
                            icon: "mdi-home-circle",
                            image: "https://app.emtool.eu/public/_lib/img/icon_delete_emt.png",
                            link: "/info",
                            id: "btn_delete",
                            disabled: false,
                            title: "Elimina",
                            width: 30

                        });



                    }

                    pulsantis.push({
                        text: "Esporta XLS",
                        icon: "mdi-arrow-left",
                        image: "https://app.emtool.eu/public/_lib/img/export-xls-emt.png",
                        link: "/confOrariChoice",
                        id: "btn_export_xls",
                        disabled: false,
                        title: "Esporta Excel",
                        width: 30
                    });





                }

                if (v_enable == true) {


                    pulsantis.push({
                        text: "Add",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/xbox-cross-emt.png",
                        link: "/settings",
                        id: "btn_add",
                        disabled: false,
                        title: "Aggiungi",
                        width: 30
                    });

                    pulsantis.push({
                        text: "Edit",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/icon_edit_emt.png",
                        link: "/info",
                        id: "btn_edit",
                        disabled: false,
                        title: "Modifica",
                        width: 30

                    });

                    if (ids != "") {

                        pulsantis.push({
                            text: "Delete",
                            icon: "mdi-home-circle",
                            image: "https://app.emtool.eu/public/_lib/img/icon_delete_emt.png",
                            link: "/info",
                            id: "btn_delete",
                            disabled: false,
                            title: "Elimina",
                            width: 30

                        });



                    }


                    // pulsantis.push({
                    //     text: "Indietro",
                    //     icon: "mdi-arrow-left",
                    //     image: "https://app.emtool.eu/public/_lib/img/back-emt.png",
                    //     link: "/confOrariChoice",
                    //     id: "btn_back",
                    //     disabled: false,
                    //     title: "Indietro",
                    //     width: 30
                    // });





                }

                this.$root.$children[0].bnavbuttons = pulsantis;

            }, 100);

        },

        setupButtonsGrid: async function () {
            setTimeout(() => {
                // console.log ("here we go" , this.$root.$children[0].drawer ) ;
                //window.App.$children[0].setToolbar();
                //   this.$root.$children[0].setToolbar();

                var pulsantis = [

                    {
                        text: "Add",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/xbox-cross-emt.png",
                        link: "/settings",
                        id: "btn_add",
                        disabled: false,
                        width: 30
                    },

                    {
                        text: "Edit",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/icon_edit_emt.png",
                        link: "/info",
                        id: "btn_edit",
                        disabled: false,
                        width: 30
                    },

                    {
                        text: "Delete",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/icon_delete_emt.png",
                        link: "/info",
                        id: "btn_delete",
                        disabled: false,
                        width: 30
                    },

                    {
                        text: "Esporta XLS",
                        icon: "mdi-arrow-left",
                        image: "https://app.emtool.eu/public/_lib/img/icon-export-xls-emt.png",
                        link: "/confOrariChoice",
                        id: "btn_export_xls",
                        disabled: false,
                        title: "Esporta Excel",
                        width: 25
                    },

                    {
                        text: "Dashboard",
                        icon: "mdi-home-circle",
                        link: "/dash",
                        id: "btn_exit",
                        disabled: false,
                    },

                ];
                //window.App.$children[0].bnavbuttons = pulsantis;
                this.$root.$children[0].bnavbuttons = pulsantis;

                setTimeout(() => {

                }, 100);

            }, 100);
        },

        setupButtons: async function () {
            setTimeout(() => {
                // console.log ("here we go" , this.$root.$children[0].drawer ) ;
                //window.App.$children[0].setToolbar();
                //   this.$root.$children[0].setToolbar();

                var pulsantis = [

                    {
                        text: "Dashboard",
                        icon: "mdi-home-circle",
                        link: "/qrconfirm",
                        id: "btn_qrcode",
                        image: "https://app.smart-book.it/public/smartbook/ICON_3.png",
                        disabled: false,
                    },

                    {
                        text: "Settings",
                        icon: "mdi-home-circle",
                        image: "https://app.smart-book.it/public/_lib/img/icons8-settings-64.png",
                        class: "inverted",
                        link: "/settings",
                        id: "btn_settings",
                        disabled: false,
                    },

                    {
                        text: "Info",
                        icon: "mdi-home-circle",
                        image: "https://app.smart-book.it/public/_lib/img/icons8-informazioni-482.png",
                        class: "inverted",
                        link: "/info",
                        id: "btn_info",
                        disabled: false,
                    },

                    {
                        text: "Pdf",
                        icon: "mdi-home-circle",
                        image: "https://app.smart-book.it/public/_lib/img/sb-export-pdf-50.png",
                        class: "inverted",
                        link: "/pdf",
                        id: "btn_pdf",
                        disabled: false,
                    },

                ];

                //window.App.$children[0].bnavbuttons = pulsantis;
                this.$root.$children[0].bnavbuttons = pulsantis;

                setTimeout(() => {

                }, 100);

            }, 100);
        },

        syncProfile: async function () {
            /*  var token = window.$cookies.get("token");
            var system = window.$cookies.get("system"); */

            //  this.data.days = response.data ;
        },

        btn_add_tms_click() {
            console.log(1);
        },
        /*          onClick() {
      console.log('a phone number was clicked');
    }
,
 */
        reply(par) {
            console.log(par);
        },

        reset() {
            this.$refs.form.reset();
        },
        resetValidation() {
            this.$refs.form.resetValidation();
        },


        exportXLS: async function () {

            var that = this;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apipratiche.goGetFiltersExportPratiche(
                0
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from goGetFiltersExportPratiche", res);


                that.gestori = res.data.gestore;
                that.tipi_progetto = res.data.tipi_progetto;
                that.stati = res.data.stato;
                that.intestatari_mandati = res.data.intestatario_mandato;
                that.anni_export = res.data.anni;


                that.textSearchExportXls = "";
                that.selPagExport = "5";
                that.filterCliente = "";

                that.tipoProgettoExportXLS = "";
                that.statoPraticaExportXLS = "";
                that.intestatarioMandatoExportXLS = "";
                that.annoExportXLS = "";
                that.gestoreExportXLS = "";


                setTimeout(() => {

                    $(".contpopupexportxls").show();

                    that.$modal.show('popupExportXls');


                }, 200);


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );


        },

        getInfoAzienda: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");


            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apisedioperative.getInfoAzienda(
                window.$cookies.get("sel_filter_sedi_oper"),
                v_token
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from getInfoAzienda", res);


                $("#divDescAzi").html(res.data.azienda.fld_name);







            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );


        },


        doxweb: async function () {

            var that = this;

            var uname = atob(window.$cookies.get("token"));

            var ids = "";

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {


                    if (ids != "") {
                        ids = ids + ",";
                    }
                    ids = ids + $(this).attr("data-id");
                }

            });


            that.$swal
                .fire({
                    title: "Doxweb",
                    html: "Sei sicuro di voler creare la folder in doxweb ?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_emt.png' />",
                    cancelButtonText: "<img title='Annulla' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_cancel3_emt.png' />",
                    customClass: {
                        cancelButton: 'order-1',
                        confirmButton: 'order-2',
                    }

                })
                .then(async function (result) {

                    if (result.value == true) {

                        that.showSpinner = true;
                        that.$root.$children[0].showProgress = true;

                        $.ajax({
                            //url: "{{ route('admin.pratiche-chk-nickname') }}",

                            url: that.getUrlDomain("apiPraticheChkName"),

                            data: { id: ids },
                            async: true,
                            success: function (res) {

                                if (res.Result == "OK") {

                                    // var pratica = ($("[data-id=" + ids + "]").parent().parent().find("td").eq(3).text());
                                    // var azienda = ($("[data-id=" + ids + "]").parent().parent().find("td").eq(4).text());

                                    var pratica = ($("[data-id=" + ids + "]").parent().parent().find("td").eq(2).text());
                                    var azienda = ($("[data-id=" + ids + "]").parent().parent().find("td").eq(3).text());

                                    var groupid = 4; //Agila Doxweb
                                    var dossiername = "";
                                    var companyname = "";
                                    var year_dossier = "";
                                    var project_type = "";


                                    $.ajax({

                                        //url: "{{ route('admin.pratiche-upd-doxweb') }}",

                                        url: that.getUrlDomain("apiPraticheUpdDoxweb"),

                                        data: { id: ids },
                                        async: true,
                                        success: function (res) {

                                            console.log(res);


                                            $.ajax({

                                                //url: "{{ url('/api/doxweb/getDossier') }}",
                                                url: that.getUrlApiDomain("getDossier"),

                                                data: { id: ids },
                                                async: true,
                                                success: function (res) {
                                                    //console.log( res.data.res[0].id ) ;
                                                    project_type = res.data.res[0].project_type;
                                                    year_dossier = res.data.res[0].year_dossier;
                                                    dossiername = res.data.res[0].dossiername;
                                                    //companyname =  res.data.res[0].companyname;
                                                    companyname = res.data.res[0].nickname_doxweb;

                                                    groupid = res.data.idGroup;

                                                    //first Call
                                                    pratica = dossiername;
                                                    azienda = companyname;
                                                    var parPath = `/home/lcservice/s3/users/admin/aziende/AGILA SRL/Pratiche/${companyname}/${project_type}/${year_dossier}/${dossiername}/`;


                                                    var tmpPath = `/home/lcservice/s3/users/admin/aziende/AGILA SRL/Pratiche/${companyname}/`;
                                                    $.ajax({
                                                        async: true,

                                                        //url: "{{ url('/api/doxweb/addCategoryDox') }}",
                                                        url: that.getUrlApiDomain("addCategoryDox"),

                                                        data: { "id": ids, "azienda": azienda, "cat": companyname, "login": uname, "parPath": tmpPath },
                                                        success: function (data) {

                                                            console.log(data);

                                                            //Sec Call
                                                            tmpPath = `/home/lcservice/s3/users/admin/aziende/AGILA SRL/Pratiche/${companyname}/${project_type}/`;
                                                            $.ajax({
                                                                async: true,

                                                                //url: "{{ url('/api/doxweb/addCategoryDox') }}",
                                                                url: that.getUrlApiDomain("addCategoryDox"),

                                                                data: { "id": ids, "azienda": azienda, "cat": project_type, "login": uname, "parPath": tmpPath }, success: function (data) {

                                                                    console.log(data);

                                                                    //Third call
                                                                    tmpPath = `/home/lcservice/s3/users/admin/aziende/AGILA SRL/Pratiche/${companyname}/${project_type}/${year_dossier}/`;
                                                                    $.ajax({
                                                                        async: false,

                                                                        //url: "{{ url('/api/doxweb/addCategoryDox') }}",
                                                                        url: that.getUrlApiDomain("addCategoryDox"),

                                                                        data: { "id": ids, "azienda": azienda, "cat": year_dossier, "login": uname, "parPath": tmpPath }, success: function (data) {

                                                                            console.log(data);

                                                                            //Last Call
                                                                            $.ajax({

                                                                                // url: "{{ url('/api/doxweb/addCategoryDox') }}",

                                                                                url: that.getUrlApiDomain("addCategoryDox"),

                                                                                data: {
                                                                                    "id": ids,
                                                                                    "azienda": azienda,
                                                                                    "cat": pratica,
                                                                                    "login": uname,
                                                                                    "parPath": parPath,

                                                                                },
                                                                                success: function (data) {
                                                                                    var res = data.created;
                                                                                    var error_msg = data.Errore;

                                                                                    if (res == "1" /*|| 1==1*/)//change
                                                                                    {

                                                                                        var idfolder = data.id;

                                                                                        var node = {};
                                                                                        node.id = idfolder;
                                                                                        node.text = "";
                                                                                        node.original = {};
                                                                                        node.original.folder_file = parPath;

                                                                                        $.ajax({


                                                                                            // url: "{{ url('/public/api/doxweb/shareFolder') }}",

                                                                                            url: that.getUrlPublicApiDomain("shareFolder"),



                                                                                            data: {
                                                                                                "node": node,
                                                                                                "azienda": azienda,
                                                                                                "cat": pratica,
                                                                                                "login": uname,

                                                                                                group_id: groupid, //agila doxweb,
                                                                                                dest: "",
                                                                                            },
                                                                                            success: function (data) {
                                                                                                //now update share

                                                                                                console.log(data);

                                                                                                $.ajax({

                                                                                                    // url: "{{ url('/public/api/doxweb/updateShareLoginFolder') }}",

                                                                                                    url: that.getUrlPublicApiDomain("updateShareLoginFolder"),


                                                                                                    data: {

                                                                                                        folder_path: parPath,
                                                                                                        login: uname,
                                                                                                        group_id: groupid,
                                                                                                    },
                                                                                                    success() {

                                                                                                        //Create and Update share //Work in progress
                                                                                                        let paths = ["Work in progress", "Documenti Definitivi", "Area documenti condivisi"];
                                                                                                        paths.forEach(el => {
                                                                                                            //console.log (el);
                                                                                                            $.ajax({
                                                                                                                async: false,

                                                                                                                // url: "{{ url('/api/doxweb/addCategoryDox') }}",

                                                                                                                url: that.getUrlApiDomain("addCategoryDox"),


                                                                                                                data: {
                                                                                                                    "id": ids,
                                                                                                                    "azienda": azienda,
                                                                                                                    "cat": el,
                                                                                                                    "login": uname,
                                                                                                                    "parPath": parPath + el + "/",

                                                                                                                },
                                                                                                                success: function (data) {

                                                                                                                    //Share and update START
                                                                                                                    var idfolderLast = data.id;
                                                                                                                    var nodeLast = {};
                                                                                                                    nodeLast.id = idfolderLast;
                                                                                                                    nodeLast.text = "";
                                                                                                                    nodeLast.original = {};
                                                                                                                    nodeLast.original.folder_file = parPath + el + "/";


                                                                                                                    $.ajax({

                                                                                                                        // url: "{{ url('/public/api/doxweb/shareFolder') }}",

                                                                                                                        url: that.getUrlPublicApiDomain("shareFolder"),


                                                                                                                        data: {
                                                                                                                            "node": nodeLast,
                                                                                                                            "azienda": azienda,
                                                                                                                            "cat": el,
                                                                                                                            "login": uname,

                                                                                                                            group_id: groupid, //agila doxweb,
                                                                                                                            dest: "",
                                                                                                                        },
                                                                                                                        success: function (data) {
                                                                                                                            //now update share

                                                                                                                            console.log(data); $.ajax({
                                                                                                                                // url: "{{ url('/public/api/doxweb/updateShareLoginFolder') }}",

                                                                                                                                url: that.getUrlPublicApiDomain("updateShareLoginFolder"),

                                                                                                                                data: {

                                                                                                                                    folder_path: parPath + el + "/",
                                                                                                                                    login: uname,
                                                                                                                                    group_id: groupid,
                                                                                                                                },
                                                                                                                                success() {

                                                                                                                                }
                                                                                                                            });

                                                                                                                        }
                                                                                                                    });
                                                                                                                    //Share and update END


                                                                                                                }
                                                                                                            });

                                                                                                        });

                                                                                                        that.$root.$children[0].showProgress = false;

                                                                                                        that.$swal({
                                                                                                            icon: 'success',
                                                                                                            title: "Successo",
                                                                                                            text: '"' + pratica + '"' + " è stata caricata in Doxweb !",
                                                                                                            showConfirmButton: false,
                                                                                                            timer: 2000

                                                                                                        });


                                                                                                        window.table.ajax.reload();

                                                                                                        that.hideShowButtons(false);

                                                                                                        // $.unblockUI();
                                                                                                        // table._fnDraw();



                                                                                                        // $(".downloadspinner").hide();



                                                                                                        //End


                                                                                                    }
                                                                                                });

                                                                                            }
                                                                                        });

                                                                                    }
                                                                                    else {

                                                                                        //$(".downloadspinner").hide()

                                                                                        that.$root.$children[0].showProgress = false;

                                                                                        that.$swal({
                                                                                            icon: 'error',
                                                                                            title: 'Error',
                                                                                            text: error_msg,
                                                                                            showConfirmButton: false,
                                                                                            timer: 1500

                                                                                        });
                                                                                    }
                                                                                }
                                                                            });
                                                                            //End Last Call

                                                                        }
                                                                    });

                                                                }
                                                            });

                                                        }
                                                    });



                                                }
                                            }); // end prima chiamta










                                        }


                                    }); // fin qui










                                }
                                else {

                                    //$(".downloadspinner").hide();

                                    that.$root.$children[0].showProgress = false;

                                    that.$swal({
                                        icon: 'error',
                                        title: "Errore",
                                        text: res.Errore + " !",
                                        showConfirmButton: false,
                                        timer: 3000
                                    });



                                }



                            }





                        });




                    }

                });

        },


        deleteRow: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");

            var ids = "";

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {


                    if (ids != "") {
                        ids = ids + ",";
                    }
                    ids = ids + $(this).attr("data-id");
                }

            });

            ids = btoa(ids) + "l";

            that.$swal
                .fire({
                    title: "Elimina",
                    html: "Vuoi eliminare l'elemento selezionato ?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_emt.png' />",
                    cancelButtonText: "<img title='Annulla' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_cancel3_emt.png' />",
                    customClass: {
                        cancelButton: 'order-1',
                        confirmButton: 'order-2',
                    }

                })
                .then(async function (result) {

                    if (result.value == true) {

                        that.showSpinner = true;
                        that.$root.$children[0].showProgress = true;

                        var response = await apipratiche.deletePratiche(
                            ids,
                            v_token
                        ).then((res) => {

                            that.$root.$children[0].showProgress = false;
                            console.log("res from deletePratiche", res);

                            that.$swal({
                                icon: "success",
                                text: "Dati eliminati correttamente",
                                showConfirmButton: false,
                                timer: 2000
                            });

                            setTimeout(() => {

                                that.dialogMsg = false;
                                that.setupButtons();


                                window.table.ajax.reload();

                                that.hideShowButtons(false);


                            }, 200);

                        }).catch(err => {
                            that.$root.$children[0].showProgress = false;
                            console.log(err);
                            var msg = err.response.data.Error;

                            that.$swal({
                                icon: "error",
                                text: msg,
                                showConfirmButton: false,
                                timer: 8000
                            });
                            console.log("Errori", "Non è stato possibile eliminare i dati");
                            console.log("response", response);

                        }

                        );

                    }

                });

        },



        deleteConditions: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");

            var ids = "";

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {


                    if (ids != "") {
                        ids = ids + ",";
                    }
                    ids = ids + $(this).attr("data-id");
                }

            });

            ids = btoa(ids) + "l";

            that.$swal
                .fire({
                    title: "Elimina Condizioni",
                    html: "Sei sicuro di voler eliminare le condizioni dai controlli selezionati ?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_emt.png' />",
                    cancelButtonText: "<img title='Annulla' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_cancel3_emt.png' />",
                    customClass: {
                        cancelButton: 'order-1',
                        confirmButton: 'order-2',
                    }

                })
                .then(async function (result) {

                    if (result.value == true) {

                        that.showSpinner = true;
                        that.$root.$children[0].showProgress = true;

                        var response = await apicontrolli.deleteCondizioni(
                            ids,
                            v_token
                        ).then((res) => {

                            that.$root.$children[0].showProgress = false;
                            console.log("res from deleteCondizioni", res);

                            that.$swal({
                                icon: "success",
                                text: "Condizioni Eliminate",
                                showConfirmButton: false,
                                timer: 2000
                            });

                            setTimeout(() => {

                                that.dialogMsg = false;
                                that.setupButtons();


                                window.table.ajax.reload();

                                that.hideShowButtons(false);


                            }, 200);

                        }).catch(err => {
                            that.$root.$children[0].showProgress = false;
                            console.log(err);
                            var msg = err.response.data.Error;

                            that.$swal({
                                icon: "error",
                                text: msg,
                                showConfirmButton: false,
                                timer: 8000
                            });
                            console.log("Errori", "Non è stato possibile eliminare i dati");
                            console.log("response", response);

                        }

                        );

                    }

                });

        },


        exportXls: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apicontrolli.exportXls(
                v_token,
                window.curSrcText,
                window.curCompany,
                window.curPrjType,
                window.curCtrType,
                window.curStatus
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from exportXls", res);

                if (res.data.Result == "OK") {



                    window.open(res.data.ValUrl, "_blank");




                }
                else {

                    that.$root.$children[0].showProgress = false;

                    that.$swal({
                        icon: "error",
                        text: res2.data.Errore,
                        showConfirmButton: false,
                        timer: 2000
                    });


                }

            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );



        },














    },
};
</script>

<style scoped>
.titlenewrow {
    justify-content: center;
    padding-top: 25px;
    padding-bottom: 30px;
    font-weight: bolder;
}

.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none;
}
</style>

<style>
.no-before::before {
    content: none !important;
}


table.dataTable.dtr-inline.collapsed>tbody>tr>td.dtr-control:before,
table.dataTable.dtr-inline.collapsed>tbody>tr>th.dtr-control:before {
    margin-right: 0.5em !important;
    display: block !important;
    box-sizing: content-box !important;
    content: "+" !important;
    color: white !important;
    top: 50% !important;
    left: 5px !important;
    height: 1em !important;
    width: 1em !important;
    margin-top: -9px !important;
    border: .15em solid white !important;
    border-radius: 1em !important;
    box-shadow: 0 0 .2em #444 !important;
    text-align: center !important;
    text-indent: 0 !important;
    font-family: "Courier New", Courier, monospace !important;
    line-height: 1em !important;
    background-color: #a4a4b0 !important;
    transform: translate(0px, 0px) !important;
}


.cont_agila_pratiche #myTable_wrapper>.dt-layout-row:first-of-type {
    top: 66px;
    position: fixed;
    left: 0px;
    min-width: 100%;
    z-index: 3;
    background-color: white;
    border: 1px solid #ffd212;
    padding-left: 3px;
    padding-right: 3px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-top: 0px;
}


.cl-radio i {
    font-size: 13px !important;
}


#fldValueOtpDelete {
    text-align: center;
    font-size: 20px
}

.dataTable tbody tr,
.dataTable tbody tr td {
    vertical-align: middle;
    padding: 6px !important;
}

.pay {
    display: flex;
    justify-content: center;
    padding-top: 10px;
    color: #f5cf2e;

}

.pay a {
    color: #f5cf2e;
    -webkit-transition: background-color 2s ease-out;
    -moz-transition: background-color 2s ease-out;
    -o-transition: background-color 2s ease-out;
    transition: background-color 2s ease-out;

}

.pay a:hover {
    color: #f5cf2e;
}

.plan {
    margin-top: 20px;
    font-size: 12px;
    display: flex;
    justify-content: center;

}

.policy {
    text-align: center;
    margin-top: 30px;
}

.version {
    font-size: 10px;
    margin-top: 25px;
    text-align: center;
}

.version span {
    font-size: 13px;
}

.titleproduct {
    font-size: 16px;
    font-size: 16px;
    color: #rgb(245, 207, 46);
    font-weight: 800;

    text-align: center;
    margin-top: 40px;

}

.Absolute-Center {

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    bottom: 0;
    height: 100px;
    left: 0;
    margin: auto;
    position: absolute;
    top: 0;
    right: 0;
    width: 300px;
}

.logo {
    text-align: center;
}

.table-responsive {
    max-width: 100vw;
}

ion-items {
    min-width: 60px;

}

ion-items ion-datetime {
    margin-left: 25px;
}

.colcontTable .col-sm-12 {
    padding:
        0px;
}

.selectpianiall {
    max-width: 21px;
    min-height: 22px;
    margin-left: 0px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    background-image: url(/smartb/img/FiltroNucleo.png);
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    transform: translateY(2px);
}

.cont-table-pratiche {
    padding-top: 14px;
    overflow-x: auto !important;
    overflow-y: hidden;

}

.cont-table-pratiche .spin {

    display: flex;
    position: absolute;
    z-index: 100;
    min-width: 100vw;
    min-height: 100vh;
    left: 0;
    top: 0;
    align-items: center;
    justify-content: center;
}

.cont_agila_pratiche {
    overflow-x: auto !important;
}


.cont_agila_pratiche table.dataTable.dtr-inline.collapsed>tbody>tr>td.dtr-control,
.cont_agila_pratiche table.dataTable.dtr-inline.collapsed>tbody>tr>th.dtr-control {
    padding-left: 25px !important;
}

.cont_agila_pratiche th {
    padding-left: 5px !important;
}

.cont_agila_pratiche ion-datetime.dateBook {
    margin-left: 16px;
}

.cont_agila_pratiche .table-responsive {
    padding: 0px;
    min-width: 80vw;
    max-width: 96vw;
}


.cont_agila_pratiche div.dataTables_wrapper div.dataTables_filter input {}

.cl-date {
    font-size: 10px;
    color: gray;
}

.cont_agila_pratiche #myTable_wrapper {
    min-width: initial;
    min-width: 2200px;
    max-width: 2200px;
    width: 2200px;
    font-size: 11px;
    color: black;
    font-weight: bold;
}

.cont_agila_pratiche #myTable {
    margin-right: 3px;
    width: 2185px !important;
}


.cont_agila_pratiche .cl_active {
    display: inline-flex;
    align-items: center;
    min-width: 100%;
    justify-content: center;
}

.cont_agila_pratiche .cl_checkall {
    padding-left: 1px;
    padding-top: 2px;
}

.cont_agila_pratiche .checkall {
    width: 13px;
    height: 13px;
}

.cont_agila_pratiche .selricerca {
    max-width: 31px;
    min-height: 31px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
    margin-right: 14px !important;
    float: right;
}

.cont_agila_pratiche .val_status {
    width: 10px !important;
}


.cont_agila_pratiche .img_centered {
    text-align: center
}




.headerSheetAziende {
    position: fixed;
    z-index: 2;
    min-width: 100vw;
    background: white;
}

.headerSheetGestori {
    position: fixed;
    z-index: 2;
    min-width: 100vw;
    background: white;
}

.itemAzienda {
    margin-left: 15px;
}

.itemGestore {
    margin-left: 15px;
}


.cont_agila_pratiche .font-row-grid-datetime {
    font-size: 10px !important;
    width: 58px !important;
}

.cont_agila_pratiche .font-row-grid-datetime-mobile {
    font-size: 10px !important;
    padding: 5px !important;
    width: 100px !important;
}

.cl-date {
    font-size: 10px;
    color: gray;
}

.cl-div-hid {
    display: none;
}

.cont_agila_pratiche .cont_buttons {
    display: flex !important;
    align-items: center !important;
    float: left !important;
    min-width: 95px !important;
    padding-left: 10px !important;
    justify-content: inherit !important;
}

.cont_agila_pratiche #myTable_filter {
    position: fixed;
    left: 0px;
    min-width: 100%;
    z-index: 3;
    background-color: white;
    border-color: #f5cf2e;

}

.cont_agila_pratiche .text_title {
    background-color: white;
    color: black;
    font-weight: bold;
    padding-top: 4px;
    padding-bottom: 4px;
    padding-left: 0px;
    font-size: 10px;
    min-width: 0vw
}

.cont_agila_pratiche .seltipoprogetto {
    max-width: 29px;
    min-height: 22px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
}

.cont_agila_pratiche .seltipo {
    max-width: 29px;
    min-height: 22px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
}

.cont_agila_pratiche .selreferente {
    max-width: 24px;
    min-height: 22px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
}

.cont_agila_pratiche .selintmand {
    max-width: 29px;
    min-height: 22px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
}

.cont_agila_pratiche .selanno {
    max-width: 29px;
    min-height: 22px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
}


.cont_agila_pratiche .cancelfilters {
    max-width: 22px;
    min-height: 22px;
    margin-left: 42px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 22px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
    margin-top: 4px;
}




.cont_agila_pratiche .seldata {
    max-width: 29px;
    min-height: 22px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
}



.cont_agila_pratiche .selgestore {
    max-width: 29px;
    min-height: 22px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
}

.cont_agila_pratiche .selpagamento {
    max-width: 29px;
    min-height: 22px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
}


.cont_agila_pratiche .selstato {
    max-width: 25px;
    min-height: 22px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
}


.cont_agila_pratiche .selazienda {
    max-width: 23px;
    min-height: 23px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 23px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
}


.cont_agila_pratiche .selmese {
    max-width: 24px !important;
    min-height: 27px !important;
    margin-left: 2px !important;
    color: black !important;
    padding: 0px 0px !important;
    min-width: 22px !important;
    text-indent: -119px !important;
    background-size: 27px !important;
    background-repeat: no-repeat !important;
    background-image: url(/emt/img/calendario-mesi-emt.png) !important;
    z-index: 2 !important;
    border: none !important;
    cursor: pointer !important;
    margin-top: 2px !important;
}

.cont_agila_pratiche .selstato2 {
    max-width: 24px !important;
    min-height: 24px !important;
    margin-left: 2px !important;
    color: black !important;
    padding: 0px 0px !important;
    min-width: 24px !important;
    text-indent: -119px !important;
    background-size: 24px !important;
    background-repeat: no-repeat !important;
    background-image: url(/emt/img/filtro-stato-emt.png) !important;
    z-index: 2 !important;
    border: none !important;
    cursor: pointer !important;
    margin-top: 2px !important;
}



.cont_agila_pratiche .text_right {
    width: 100% !important;
    text-align: right !important;
}

.cont_agila_pratiche .text_right2 {
    width: 100% !important;
    text-align: right !important;
}

.cont_agila_pratiche .content_wrap_buttons {}

.cont_agila_pratiche .wrap_buttons {
    max-height: 40px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
}


@media screen and (max-width: 960px) {

    .cont_agila_pratiche .cl_active {
        display: contents;
        align-items: center;
        justify-content: flex-start;
        text-align: center;
    }

    .cont_agila_pratiche #myTable {
        /* margin-top:54px; */
    }

    .cont_agila_pratiche #myTable_filter {
        top: 56px;
        position: fixed;

    }

    .cont_agila_pratiche .cont_buttons {
        height: 40px;
        overflow-y: hidden;
        overflow-x: auto;
        padding-left: 0px;
    }

    .cont_agila_pratiche .content_wrap_buttons {
        display: flex;
        flex-direction: row;
        overflow-x: auto;
        max-width: 225px;
        height: 40px;
    }

    .cont_agila_pratiche .wrap_buttons {
        max-height: 40px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

}

@media screen and (max-width: 1024px) {

    .contIcon {
        display: inherit;
    }



    .cont_agila_pratiche #myTable {
        max-width: 100vw !important;
        margin-right: 0px;
        min-width: 100vw !important;
        position: relative;
        width: 100vw !important;

    }

    .cont_agila_pratiche #myTable_filter {
        top: 56px;
        position: fixed;

    }

    .cont_agila_pratiche .table-responsive {
        padding: 0px;
        min-width: 95vw !important;
        max-width: 95vw !important;
        left: 0px;
        position: fixed;

    }

    .cont_agila_pratiche #myTable_wrapper {
        min-width: initial;
        min-width: 100vw !important;
        max-width: 100vw !important;
        width: 100vw !important;
        overflow-x: hidden !important;
    }

    .cont_agila_pratiche .cl_num {
        margin-left: -2px !important;
    }



    .cont_agila_pratiche .cl-nome {
        width: 105px;
    }

    .font-row-grid-datetime {
        font-size: 10px !important;
        width: 100px !important;
        display: inline-table !important;
    }

    .cont_agila_pratiche .img_centered {
        display: inline;
    }

    .cont_agila_pratiche .cl_checkall {
        padding-left: 19px;
        padding-top: 2px;
    }




}
</style>
